/**
 * Theme js
 *
 * @package Dev
 */

"use strict";

// Set scrollbar width.
// function btyScrollBar(doc = document) {
//   let domId = document.getElementById("dynamic-variables-theme-css");
//   if (!domId) {
//     return;
//   }

//   let scrollbarWidth = window.innerWidth - document.body.clientWidth,
//     megaMenu = doc.querySelector(".header-nav .mega-menu-wrap"),
//     currentWidth = window.innerWidth - document.documentElement.clientWidth;

//   // Custom event.
//   const scrollbarEvent = new Event("scrollbar-width");

//   const observer = new ResizeObserver(() => {
//     const newWidth = window.innerWidth - document.documentElement.clientWidth;

//     if (newWidth !== currentWidth) {
//       scrollbarEvent.detail = {
//         previous: currentWidth,
//         current: newWidth,
//       };

//       currentWidth = newWidth;

//       window.dispatchEvent(scrollbarEvent);
//     }
//   });

//   observer.observe(document.documentElement);

//   // First load.
//   const updateContainerContent = function () {
//     const initialWidth =
//       window.innerWidth - document.documentElement.clientWidth;
//     domId.innerHTML =
//       ":root{--scrollbar-width:" +
//       initialWidth +
//       "px;--container-content:" +
//       (megaMenu ? megaMenu.offsetWidth : 0) +
//       "px}";
//   };

//   updateContainerContent();
//   window.addEventListener("resize", updateContainerContent);

//   // Start listening for changes.
//   window.addEventListener("scrollbar-width", function (e) {
//     let newMegaMenu = doc.querySelector(
//       ".header-nav .mega-menu-wrap .container .mega-menu",
//     );
//     domId.innerHTML =
//       ":root{--scrollbar-width:" +
//       e.detail.current +
//       "px;--container-content:" +
//       (newMegaMenu ? newMegaMenu.offsetWidth : 0) +
//       "px}";
//   });

//   return observer;
// }

// Siblings.
function btySiblings(el, filter) {
  // create an empty array.
  let siblings = [];

  // if no parent, return empty list.
  if (!el || !el.parentNode) {
    return siblings;
  }

  // first child of the parent node.
  let sibling = el.parentNode.firstElementChild;

  // loop through next siblings until `null`.
  do {
    // push sibling to array.
    if (sibling != el && (!filter || filter(sibling))) {
      siblings.push(sibling);
    }
  } while ((sibling = sibling.nextElementSibling));

  return siblings;
}

// Slide up.
function btySlideUp(target, duration = 200) {
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.height = target.offsetHeight + "px";
  target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;

  window.setTimeout(function () {
    target.style.display = "none";
    target.style.removeProperty("height");
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
}

// Slide down.
function btySlideDown(target, duration = 200) {
  target.style.removeProperty("display");
  let display = window.getComputedStyle(target).display;

  if ("none" === display) {
    display = "block";
  }

  target.style.display = display;

  let height = target.offsetHeight;

  target.style.overflow = "hidden";
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.height = height + "px";

  target.style.removeProperty("padding-top");
  target.style.removeProperty("padding-bottom");
  target.style.removeProperty("margin-top");
  target.style.removeProperty("margin-bottom");

  window.setTimeout(function () {
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
}

// Toggle dropdown.
function btyToggleDropdown(doc = document) {
  let toggle = doc.querySelectorAll(".toggle-dropdown .dropdown-summary");
  if (!toggle.length) {
    return;
  }

  toggle.forEach(function (el) {
    let parent = el.parentNode,
      title = el.querySelector(".summary-info"),
      mobileTitle = el.parentNode.querySelector(".dropdown-content-title");

    const clickAnyWhere = function (e) {
      let target = e.target;

      if (
        target === el ||
        target.classList.contains("content") ||
        target.closest(".dropdown-summary")
      ) {
        return;
      }

      if (target.classList.contains("tab-head", "active")) {
        if (title) {
          title.innerText = target.innerText;
        }

        if (mobileTitle) {
          mobileTitle.innerText = target.innerText;
        }
      }

      parent.removeAttribute("open");

      document.removeEventListener("click", clickAnyWhere);
    };

    el.onclick = function (e) {
      document.addEventListener("click", clickAnyWhere);

      let aria = el.hasAttribute("aria-expanded");

      if (parent.hasAttribute("open")) {
        parent.removeAttribute("open");

        if (aria) {
          el.setAttribute("aria-expanded", "false");
        }
      } else {
        let sibling = parent.parentNode.querySelector(".toggle-dropdown[open]");
        if (sibling) {
          sibling.removeAttribute("open");

          let sibAria = sibling.querySelector(
            ".dropdown-summary[aria-expanded]",
          );
          if (sibAria) {
            sibAria.setAttribute("aria-expanded", "false");
          }
        }

        parent.setAttribute("open", "");

        if (aria) {
          el.setAttribute("aria-expanded", "true");
        }
      }
    };
  });
}

// Update aria expanded for summary <details> tag only.
function btyToggleDetails(doc = document) {
  let details = doc.querySelectorAll("details");
  if (!details.length) {
    return;
  }

  details.forEach(function (el) {
    let summary = el.querySelector("summary");
    if (
      el.classList.contains("product-accordion") ||
      el.classList.contains("collapsible-item") ||
      el.classList.contains("order-note") ||
      !summary
    ) {
      return;
    }

    document.addEventListener("click", function (e) {
      let target = e.target;

      if (
        target === el ||
        el.contains(target) ||
        target.closest(".toggle-dropdown")
      ) {
        return;
      }

      let tmpAria = doc.querySelector("[open] [aria-expanded]");
      if (tmpAria) {
        tmpAria.setAttribute("aria-expanded", "false");
      }
    });

    el.onclick = function (e) {
      let aria = summary.getAttribute("aria-expanded");
      if (!aria) {
        return;
      }

      if ("string" === typeof el.getAttribute("open")) {
        if (aria) {
          summary.setAttribute("aria-expanded", "false");
        }
      } else {
        let sibling = el.parentNode.querySelector("[open]");
        if (sibling) {
          let sibAria = sibling.querySelector("[open] [aria-expanded]");
          if (sibAria) {
            sibAria.setAttribute("aria-expanded", "false");
          }
        }

        if (aria) {
          summary.setAttribute("aria-expanded", "true");
        }
      }
    };
  });
}

// Json parse.
function btyJsonParse(string) {
  try {
    return JSON.parse(string.trim());
  } catch (e) {
    return false;
  }
}

// Remove item in array.
function btyRemoveArrayItem(arr = [], item) {
  if (!arr.length || !item) {
    return [];
  }

  return arr.filter(function (el) {
    return el != item;
  });
}

// Set delay time when user typing.
const btySearchDelay = (function (timer = 0) {
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

// Get image src.
function btyGetImageSrc(img) {
  // Create canvas.
  let canvas = document.createElement("canvas"),
    context = canvas.getContext("2d");

  // Set width and height.
  canvas.width = img.width;
  canvas.height = img.height;

  // Draw the image.
  context.drawImage(img, 0, 0);

  return canvas.toDataURL("image/jpeg", 1.0);
}

// Scrolling detect direction.
function btyScrollingDetect() {
  let body = document.body;

  if (window.oldScroll > window.scrollY) {
    body.classList.add("direction-up");
    body.classList.remove("direction-down");
  } else {
    body.classList.remove("direction-up");
    body.classList.add("direction-down");
  }

  // Reset state.
  window.oldScroll = window.scrollY;
}

// Set loading animation for image.
function btyImageLoad(image, image_src, image_key, ele_loading) {
  let newImage = new Image();

  newImage.crossOrigin = "anonymous";

  // Check local storage first.
  if (sessionStorage.getItem(image_key)) {
    image.src = sessionStorage.getItem(image_key);
    return;
  }

  // Add loading animation.
  image.parentNode.classList.add("loading");

  // Handle.
  newImage.onload = function () {
    ele_loading.classList.remove("loading");
    let renderImage = btyGetImageSrc(newImage);

    // Set final image src.
    image.src = renderImage;

    // Save image to local storage.
    if (image_key) {
      sessionStorage.setItem(image_key, renderImage);
    }
  };

  newImage.onerror = function () {
    ele_loading.classList.remove("loading");
  };

  // Set image src for 'newImage.onload' function handle.
  newImage.src = image_src;
}

// Get form data.
function btySerializeForm(form, type = "string") {
  let obj = {},
    formData = new FormData(form);

  for (let key of formData.keys()) {
    obj[key] = formData.get(key);
  }

  return "string" === type ? JSON.stringify(obj) : obj;
}

// Get price format.
function btyFormatPrice(money = 0, format = false) {
  if ("string" === typeof money) {
    money = money.replace(".", "");
  }

  if (false === format) {
    format = btyGlobals.money_format;
  }

  let value = "",
    placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function defaultOption(opt, def) {
    return "undefined" === typeof opt ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    let parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      money = parts[1] ? decimal + parts[1] : "";

    return dollars + money;
  }

  switch (format.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(money, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(money, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(money, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(money, 0, ".", ",");
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(money, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(money, 2, " ", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(money, 0, ".", "");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(money, 2, "'", ".");
      break;
  }

  return format.replace(placeholderRegex, value);
}

// Render price html.
function btyPriceHtml(
  price,
  compare_price = false,
  unit_price = false,
  unit_price_measurement = {},
) {
  let html = "",
    regularPrice = btyStrings.product.regular_price;

  if (compare_price) {
    html += '<s class="regular-price">';
    html += '<span class="sr-only">' + regularPrice + ": </span>";
    html += btyFormatPrice(compare_price);
    html += "</s>";

    html += '<span class="price">';
    html +=
      '<span class="sr-only">' + btyStrings.product.sale_price + ": </span>";
    html += btyFormatPrice(price);
    html += "</span>";
  } else {
    html += '<span class="regular-price">';
    html += '<span class="sr-only">' + regularPrice + ": </span>";
    html += btyFormatPrice(price);
    html += "</span>";
  }

  if (unit_price) {
    html += '<span class="unit-price">';
    html +=
      btyFormatPrice(unit_price) + "/" + unit_price_measurement.quantity_unit;
    html += "</span>";
  }

  return html;
}

// Parse html dom.
function btyGetSectionHtml(
  text = "",
  selector = ".shopify-section",
  html = "inner",
) {
  let el = new DOMParser()
    .parseFromString(text, "text/html")
    .querySelector(selector);

  return el ? ("inner" === html ? el.innerHTML : el.outerHTML) : "";
}

/**
 * Update html dom.
 *
 * @param  array sections The response sections.
 * @param  array modules  The modules need update html dom.
 */
function btyUpdateHtml(sections, modules) {
  modules.forEach(function (mod) {
    let query = document.querySelectorAll(mod.node);
    if (!query.length) {
      return;
    }

    query.forEach(function (el) {
      el.innerHTML = btyGetSectionHtml(sections[mod.section], mod.selector);
    });

    // Re-init function.
    btyAddToCart();
    btySwatch();
    btyQuickAdd();
  });
}

// Countdown time.
function btyCountdownTime(doc = document) {
  let selectors = doc.querySelectorAll(".countdown-time");

  if (!selectors.length) {
    return;
  }

  selectors.forEach(function (el) {
    let time = el.getAttribute("data-time"),
      dayField = el.querySelector(".days"),
      hourField = el.querySelector(".hours"),
      minuteField = el.querySelector(".minutes"),
      secondField = el.querySelector(".seconds");

    if (!dayField || !hourField || !minuteField || !secondField) {
      return;
    }

    // Check time first.
    if (isNaN(Date.parse(time))) {
      return;
    }

    // Convert to milisecond.
    let interval,
      second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24,
      today = new Date();

    const countDownFn = function () {
      let countDown = new Date(time).getTime(),
        now = new Date().getTime(),
        distance = countDown - now,
        dayInner = Math.floor(distance / day);

      if (distance < 0) {
        el.parentNode.remove();

        clearInterval(init);

        return;
      }

      if (0 == dayInner && dayField) {
        dayField.parentNode.remove();
      } else {
        dayField.innerText = dayInner;
      }

      hourField.innerText = ("0" + Math.floor((distance % day) / hour)).slice(
        -2,
      );
      minuteField.innerText = (
        "0" + Math.floor((distance % hour) / minute)
      ).slice(-2);
      secondField.innerText = (
        "0" + Math.floor((distance % minute) / second)
      ).slice(-2);

      // Show countdown.
      el.parentNode.classList.remove("hidden");
    };

    let init = setInterval(countDownFn, 0);
  });
}

/**
 * Close theme popup
 *
 * @param  string class_name  Class name remove form <html>
 * @return node   parent_node Parent node to implement click overlay.
 */
function btyClosePopup(class_name, parent_node, overlay = true) {
  if (!class_name) {
    return;
  }

  let doc = document.documentElement,
    button = parent_node ? parent_node.querySelector(".close-button") : false,
    triggerElement = parent_node ? parent_node.triggerElement : null;

  // Click to popup overlay.
  if (parent_node && overlay) {
    const parentHandle = function (e) {
      if (e.target != parent_node) {
        return;
      }

      doc.classList.remove(class_name);
      parent_node.removeEventListener("click", parentHandle);
      document.dispatchEvent(new CustomEvent("theme-popup-close"));

      // Refocus on the element that opened the popup.
      if (triggerElement) {
        triggerElement.focus();
      }
    };

    parent_node.addEventListener("click", parentHandle);
  }

  // Use ESC key.
  doc.addEventListener("keyup", function (e) {
    if (27 !== e.keyCode) {
      return;
    }

    doc.classList.remove(class_name);
    document.dispatchEvent(new CustomEvent("theme-popup-close"));

    // Refocus on the element that opened the popup.
    if (triggerElement) {
      triggerElement.focus();
    }
  });

  // Use close button.
  if (button) {
    const buttonHandle = function () {
      doc.classList.remove(class_name);
      button.removeEventListener("click", buttonHandle);
      document.dispatchEvent(new CustomEvent("theme-popup-close"));

      // Refocus on the element that opened the popup.
      if (triggerElement) {
        triggerElement.focus();
      }
    };

    button.addEventListener("click", buttonHandle);
  }
}

// Quick search.
function btyQuickSearch() {
  let actions = document.querySelectorAll(".action-search");
  if (!actions.length || document.body.classList.contains("template-search")) {
    return;
  }

  let dialog = document.querySelector(".quick-search"),
    input = dialog ? dialog.querySelector(".search-input") : false,
    button = dialog ? dialog.querySelector(".search-button") : false,
    suggestions = dialog ? dialog.querySelector(".suggestions-product") : false;

  if (!input || !button) {
    return;
  }

  if (
    Shopify.designMode &&
    document.documentElement.classList.contains("quick-search-open")
  ) {
    btyClosePopup("quick-search-open", dialog);
  }

  // Toggle quick search.
  actions.forEach(function (el) {
    el.onclick = function (e) {
      e.preventDefault();

      // Save the element that opens the popup.
      dialog.triggerElement = el;

      // Focus input field.
      input.focus();
      input.removeAttribute("tabindex");

      document.documentElement.classList.add("quick-search-open");
      btyClosePopup("quick-search-open", dialog);

      btyTrapFocus(dialog, input);
    };
  });
}

// Quantity button.
function btyQuantityButton(doc = document) {
  let buttons = doc.querySelectorAll(".quantity-button");
  if (!buttons.length) {
    return;
  }

  buttons.forEach(function (el) {
    let eventChange = new Event("change", { bubbles: true });

    el.onclick = function () {
      let input = el.parentNode.querySelector(".quantity-input");
      if (!input) {
        return;
      }

      let current = Number(input.value || 0),
        step = Number(input.getAttribute("step") || 1),
        min = Number(input.getAttribute("min") || 0),
        max = Number(input.getAttribute("max")),
        name = el.name;

      if ("minus" === name && current >= step) {
        // Minus button.
        if (current <= min || current - step < min) {
          return;
        }

        input.value = current - step;
      } else if ("plus" === name) {
        // Plus button.
        if (max && (current >= max || current + step > max)) {
          return;
        }

        input.value = current + step;
      }

      // Trigger event.
      input.dispatchEvent(eventChange);
    };
  });
}

// Main menu.
function btyNavMenu(doc = document, event = false) {
  let toggle = doc.querySelector(".toggle-panel-button"),
    panel = doc.querySelector(".site-panel"),
    toggleOpen = toggle ? toggle.querySelector(".toggle-open") : false;

  if (!toggle || !panel || !toggleOpen) {
    return;
  }

  // Close site panel when settings update.
  if (event && event.detail.load) {
    btyClosePopup("site-panel-open", panel);
    btyClosePopup("site-panel-open", toggle);
  }

  // Toggle site panel.
  toggleOpen.onclick = function () {
    document.documentElement.classList.add("site-panel-open");

    btyClosePopup("site-panel-open", panel);
    btyClosePopup("site-panel-open", toggle);
  };

  // Toggle sub menu.
  let links = doc.querySelectorAll(".site-panel .has-children");
  if (!links.length) {
    return;
  }

  links.forEach(function (el) {
    el.onclick = function (e) {
      if (e.target.classList.contains("menu-text")) {
        return;
      }

      e.preventDefault();

      let menu = el.closest(".toggle-navigation"),
        parent = el.parentNode,
        subMenu =
          parent.querySelector(".sub-menu") ||
          parent.querySelector(".sub-mega-menu");
      if (!subMenu) {
        return;
      }

      parent.classList.add("active");

      // Update current sub menu.
      let level = Number(subMenu.getAttribute("data-level") || 1),
        back = parent.querySelector(".back");
      if (level) {
        menu.setAttribute("data-level", level);
      }

      // Go back parent level.
      if (back) {
        back.onclick = function () {
          parent.classList.remove("active");
          menu.setAttribute("data-level", level - 1);
        };
      }
    };
  });
}

// Account popup.
function btyAccountPopup(doc = document) {
  let selectors = doc.querySelectorAll(".action-account"),
    customer = document.querySelector(".customer-wraper");
  if (
    !selectors.length ||
    !customer ||
    document.body.classList.contains("has-account-details")
  ) {
    return;
  }

  // Get display style.
  const getStyles = function (el, property = "display") {
    let obj = window.getComputedStyle(el, null);

    return obj.getPropertyValue(property);
  };

  // Get first input field.
  const getInput = function (parent) {
    return parent.querySelector(".field input");
  };

  // Toggle popup.
  selectors.forEach(function (el) {
    el.onclick = function (e) {
      if (el.classList.contains("new-customer-accounts")) {
        return;
      }

      e.preventDefault();

      let login = customer.querySelector(".login"),
        loginBox = login ? login.querySelector("#login-container") : false,
        recover = login ? login.querySelector("#recover-container") : false,
        register = customer.querySelector(".register");

      if (!recover || !loginBox || !register) {
        return;
      }

      document.documentElement.classList.add("customer-open");

      // Focus input field on desktop.
      if (window.matchMedia("(min-width: 992px)").matches) {
        if (getStyles(register) === "block") {
          getInput(register).focus();
        } else if (getStyles(recover) === "block") {
          getInput(recover).focus();
        } else if (getStyles(loginBox) === "block") {
          getInput(loginBox).focus();
        }
      }

      // Close popup.
      btyClosePopup("customer-open", customer);

      customer.onclick = function (e) {
        let target = e.target;

        // Create account.
        if (target.classList.contains("create-account")) {
          e.preventDefault();

          login.classList.add("hidden");
          register.classList.remove("hidden");

          getInput(register).focus();
        }

        // Sign-in.
        if (target.classList.contains("sign-in")) {
          e.preventDefault();

          login.classList.remove("hidden");
          register.classList.add("hidden");

          getInput(loginBox).focus();
        }

        // Fogot password.
        if (target.classList.contains("forgot-password")) {
          setTimeout(function () {
            getInput(recover).focus();
          });
        }

        // Cancel login.
        if (target.classList.contains("login-cancel")) {
          setTimeout(function () {
            getInput(loginBox).focus();
          });
        }
      };
    };
  });
}

// Update cart item count.
function btyCartItemCount(items = 1) {
  let count = document.querySelectorAll(".cart-item-count");
  if (!count.length) {
    return;
  }

  items = Number(items);

  count.forEach(function (el) {
    el.innerHTML = items;

    if (items < 1) {
      el.classList.add("hidden");
    } else {
      el.classList.remove("hidden");
    }
  });
}

// Find if two arrays contain any common item in Javascript.
function btyDiffObject(haystack, arr) {
  return arr.every(function (v) {
    return haystack.includes(v);
  });
}

// Selected variant image.
function btySelectedVariant(variant, data) {
  for (let opt in data) {
    if (btyDiffObject(Object.values(variant), data[opt].options)) {
      return data[opt];
    }
  }
}

// Fetch cart data.
function btyFetchCart(obj, modules, item) {
  let body = JSON.stringify(obj);

  fetch(btyGlobals.cart_change_url, { ...btyFetchConfig(), ...{ body } })
    .then(function (r) {
      return r.json();
    })
    .then(function (res) {
      let warning = item.querySelectorAll(".product-warning");
      if (warning.length) {
        warning.forEach(function (el) {
          el.innerHTML = "";
        });
      }

      if (res.errors && warning.length) {
        warning.forEach(function (el) {
          el.innerHTML = btyGlobals.svg_warning + res.errors;
        });

        let qtyInput = item.querySelectorAll(".quantity-input");
        if (qtyInput.length) {
          qtyInput.forEach(function (el) {
            el.value = el.getAttribute("data-qty");
          });
        }

        return;
      }

      // Update cart item count first.
      btyCartItemCount(res.item_count);

      // Cart empty.
      if (!res.items.length) {
        let cartTable = document.querySelector(".cart-page-section .container"),
          cartSubtotal = cartTable
            ? cartTable.querySelector(".cart-footer")
            : false,
          sideCartContent = document.querySelector(".side-cart-content"),
          sideCartFooter = document.querySelector(".side-cart-footer");

        // Update cart table section.
        if (cartTable) {
          cartTable.innerHTML = btyGetSectionHtml(
            res.sections["main-cart"],
            ".container",
          );
        }

        // Remove cart subtotal section.
        if (cartSubtotal) {
          cartSubtotal.remove();
        }

        // Update side cart content.
        if (sideCartContent) {
          sideCartContent.innerHTML = btyGetSectionHtml(
            res.sections["side-cart"],
            ".side-cart-content",
          );
        }

        // Remove side cart footer.
        if (sideCartFooter) {
          sideCartFooter.remove();
        }

        // Open login popup when cart empty.
        btyAccountPopup();
      }

      // Update current item.
      let currentItem = res.items.filter((e) => e.id === Number(obj.id));
      if (currentItem.length) {
        let sidecartContent = item.closest(".side-cart-content"),
          totalPrice = item.querySelector(".totals-item-price"),
          quantityUnit = item.querySelectorAll('[name="quantity"]');
        if (totalPrice) {
          totalPrice.innerHTML = btyGetSectionHtml(
            res.sections["main-cart"],
            '[data-id="' + obj.id + '"] .totals-item-price',
          );
        }

        if (sidecartContent) {
          item.innerHTML = btyGetSectionHtml(
            res.sections["side-cart"],
            '[data-id="' + obj.id + '"]',
          );
        }

        if (quantityUnit.length) {
          quantityUnit.forEach(function (el) {
            el.setAttribute("data-qty", obj.quantity);
          });
        }
      } else {
        
        item.remove();
      }

      // Update html.
      btyUpdateHtml(res.sections, modules);

      // Re-init quantity button.
      btyQuantityButton();

      // Re-init update product quantity.
      btyUpdateProductQuantity();

      // Update cart progress bar.
      btyUpdateProgressBarCart(res.total_price);

      // Re-init cart popup outer.
      btySideCartPopupOuter();

      // Reinit checkbox agree to terms.
      btyAgreeToTerms();
    })
    .catch(function (e) {
      console.error(e);
    })
    .finally(function () {
      // Remove loading.
      item.classList.remove("updating");
    });
}

// Update product quantity.
function btyUpdateProductQuantity(doc = document) {
  let item = doc.querySelectorAll(".product-item[data-id]");
  if (!item.length) {
    return;
  }

  // Register dom html need an update when the response available.
  let modules = [
    {
      node: ".cart-totals",
      section: "main-cart",
      selector: ".cart-totals",
    },
    {
      node: ".agree-to-terms",
      section: "main-cart",
      selector: ".agree-to-terms",
    },
    {
      node: ".side-cart .sub-total",
      section: "side-cart",
      selector: ".side-cart .sub-total",
    },
    {
      node: ".side-cart .agree-to-terms",
      section: "side-cart",
      selector: ".side-cart .agree-to-terms",
    },
  ];

  item.forEach(function (el) {
    let id = el.getAttribute("data-id");

    if (!id) {
      return;
    }

    let removes = el.querySelectorAll(".product-remove"),
      inputs = el.querySelectorAll(".quantity-input");

    // Quantity change.
    if (inputs.length) {
      inputs.forEach(function (input) {
        input.onchange = function () {
          let data,
            quantity = Number(input.value.trim());

          // Loading effect.
          el.classList.add("updating");

          data = {
            id: id,
            quantity: quantity,
            sections: modules.map((s) => s.section),
            sections_url: window.location.pathname,
          };

          // Fetch data.
          btyFetchCart(data, modules, el);
        };
      });
    }

    // Remove button click.
    if (removes.length) {
      removes.forEach(function (remove) {
        remove.onclick = function (e) {
          e.preventDefault();

          // Loading effect.
          el.classList.add("updating");

          let data = {
            id: id,
            quantity: 0,
            sections: modules.map((s) => s.section),
            sections_url: window.location.pathname,
          };

          // Fetch data.
          btyFetchCart(data, modules, el);
        };
      });
    }
  });
}

// Variant options.
function btyProductVariants(doc = document, output = false) {
  let data,
    selector = doc.querySelectorAll(".product-variants");
  if (!selector.length) {
    return;
  }

  selector.forEach(function (sl) {
    let variants = sl.parentNode.querySelector("[data-product-variants]"),
      quantity = sl.parentNode.querySelector("[data-inventory-quantity]"),
      field = sl.querySelectorAll(".field-value");
    if (!field.length || !variants | !quantity) {
      return;
    }

    let product = sl.closest(".main-product"),
      gallery = product ? product.querySelector(".product-gallery") : false,
      featured = sl.closest(".featured-product-product"),
      image = featured ? featured.querySelector(".media-preview") : false,
      summary = sl.closest(".product-summary"),
      variant_pick = {};

    variants = btyJsonParse(variants.textContent);
    quantity = btyJsonParse(quantity.textContent);

    let price = summary.querySelector(".product-price"),
      form = summary.querySelector('[data-type="add-to-cart-form"]'),
      input = form ? form.querySelector(".quantity-input") : false,
      productId = form ? form.querySelector('[name="id"]') : false,
      button = form ? form.querySelector('[name="add"]') : false,
      productUrl = sl.getAttribute("data-url"),
      pickup = summary.querySelector(".pickup-availability"),
      amount = summary.querySelector(
        ".product-sale-label .sale-total .saved-number",
      ),
      sku = summary.querySelector(
        ".product-information .product-sku .info-value",
      ),
      barcode = summary.querySelector(
        ".product-information .product-barcode .info-value",
      );

    field.forEach(function (el) {
      if ("radio" === el.type) {
        if (el.checked) {
          variant_pick[el.name] = el.value;
        }
      } else {
        variant_pick[el.name] = el.value;
      }

      el.onchange = function () {
        variant_pick[el.name] = el.value;

        // Update stock status.
        btyUpdateStockStatusProduct(variants, sl);

        // When variant change.
        let selected = btySelectedVariant(variant_pick, variants);

        if (selected) {
          // Check variant selling plan.
          if (form) {
            let sellingMessage = form.parentNode.querySelector(
                ".selling-plan-message",
              ),
              button = form.querySelector(".add-to-cart-button"),
              paymentButton = form.querySelector(".shopify-payment-button");

            if (
              sellingMessage &&
              !sellingMessage.classList.contains("hidden")
            ) {
              sellingMessage.innerHTML = "";
              sellingMessage.classList.add("hidden");
            }

            if (
              selected.requires_selling_plan &&
              selected.selling_plan_allocations.length == 0
            ) {
              if (button) {
                button.classList.add("selling-plan-error");
              }

              if (paymentButton) {
                paymentButton.classList.add("hidden");
              }
            } else {
              if (button) {
                button.classList.remove("selling-plan-error");
              }

              if (paymentButton) {
                paymentButton.classList.remove("hidden");
              }
            }
          }

          // Update product variant ID.
          if (productId) {
            productId.value = selected.id;
          }

          // Update product SKU.
          if (sku) {
            if (selected.sku) {
              sku.parentNode.classList.remove("hidden");
              sku.innerHTML = selected.sku;
            } else {
              sku.parentNode.classList.add("hidden");
            }
          }

          // Update product Barcode.
          if (barcode) {
            if (selected.barcode) {
              barcode.parentNode.classList.remove("hidden");
              barcode.innerHTML = selected.barcode;
            } else {
              barcode.parentNode.classList.add("hidden");
            }
          }

          // Update image on Featured product.
          if (image && selected.featured_image) {
            image.removeAttribute("srcset");
            btyImageLoad(
              image,
              selected.featured_image.src,
              selected.featured_media.id,
              image.parentNode,
            );
          }

          // Update product url, for product page only.
          if (productUrl && gallery) {
            window.history.replaceState(
              {},
              "",
              productUrl + "?variant=" + selected.id,
            );
          }

          // Update price.
          if (price) {
            price.innerHTML = btyPriceHtml(
              selected.price,
              selected.compare_at_price,
              selected.unit_price,
              selected.unit_price_measurement,
            );
          }

          // Update saved price badge.
          if (amount) {
            if (selected.compare_at_price) {
              let amountTotal =
                (100 * (selected.compare_at_price - selected.price)) /
                selected.compare_at_price;

              amount.innerHTML = amountTotal.toFixed(0);

              amount.closest(".summary-item").classList.remove("hidden");
            } else {
              amount.closest(".summary-item").classList.add("hidden");
            }
          }

          // Set max quantity.
          if (input) {
            let max = quantity.filter(function (e) {
              return e.id === selected.id;
            });

            if (max.length) {
              let qty = max[0].qty;

              if (qty > 0) {
                if (Number(input.value) > qty) {
                  input.value = qty;
                }

                input.setAttribute("max", qty);
              } else {
                input.removeAttribute("max");
              }
            } else {
              input.removeAttribute("max");
            }
          }

          // Group image.
          let groupImage = document.querySelectorAll(
            ".check-group-image .swiper[data-color]",
          );
          if (groupImage.length) {
            let colorName =
              selected.featured_media && selected.featured_media.alt
                ? selected.featured_media.alt.split("_")[0]
                : false;
            if (colorName) {
              groupImage.forEach(function (gi) {
                let label = gi.getAttribute("data-color");
                if (!label) {
                  return;
                }

                if (colorName.trim().toLowerCase() == label) {
                  gi.classList.remove("group-hidden");
                } else {
                  gi.classList.add("group-hidden");
                }
              });
            }
          } else {
            // Scroll to current variant media.
            // let headerSticky = document.querySelector(".header.is-sticky"),
            //   headerHeight = headerSticky ? headerSticky.offsetHeight : 0,
            //   currentMedia =
            //     gallery &&
            //     "layout-1" == gallery.getAttribute("data-id") &&
            //     selected.featured_media
            //       ? gallery.querySelector(
            //           '.media-preview-wrap[data-id="' +
            //             selected.featured_media.id +
            //             '"]',
            //         )
            //       : false;
            // if (
            //   currentMedia &&
            //   window.matchMedia("(min-width: 992px)").matches
            // ) {
            //   window.scrollTo({
            //     top:
            //       currentMedia.getBoundingClientRect().top +
            //       window.pageYOffset -
            //       headerHeight,
            //     behavior: "smooth",
            //   });
            // }
          }
        }

        // Update shop pay installments.
        let shopifyPayment = document.querySelector("shopify-payment-terms");
        if (shopifyPayment) {
          shopifyPayment.setAttribute("variant-id", selected.id);
        }

        // Pickup availability, sold out products should not show the pickup availability.
        if (pickup) {
          if (selected && selected.available) {
            btyPickupAvailability(doc, productId.value, pickup);
          } else {
            pickup.innerHTML = "";
          }
        }

        // Update selected option.
        let selectedOption = el
          .closest(".variant-field")
          .querySelector(".field-title .selected-value");
        if (selectedOption) {
          selectedOption.innerText = el.value.trim();
        }

        // Update form state.
        if (form) {
          if (selected && selected.available) {
            form.classList.remove("disabled");
          } else {
            form.classList.add("disabled");
          }
        }

        // Update add to cart button text.
        if (button) {
          if (selected) {
            if (selected.available) {
              button.innerHTML = btyStrings.product.add_to_cart;
              button.classList.remove("disabled");
              price.classList.remove("hidden");
            } else {
              button.innerHTML = btyStrings.product.out_of_stock;
              button.classList.add("disabled");
              price.classList.remove("hidden");
            }
          } else {
            price.classList.add("hidden");
            button.classList.add("disabled");
            button.innerHTML = btyStrings.product.unavailable;
          }
        }

        // Add custo event.
        const customData = {
          detail: {
            selected: selected,
          },
        };

        const customEvent = new CustomEvent(
          "product-variant-updated",
          customData,
        );
        document.dispatchEvent(customEvent);
      };
    });

    // Update stock status, first load.
    btyUpdateStockStatusProduct(variants, sl);

    // Pickup availability, sold out products should not show the pickup availability.
    let firstSelected = btySelectedVariant(variant_pick, variants);
    if (pickup && firstSelected && firstSelected.available) {
      btyPickupAvailability(doc, firstSelected.id, pickup);
    }

    // Add custo event.
    const customData = {
      detail: {
        selected: firstSelected,
      },
    };

    const customEvent = new CustomEvent("product-variant-updated", customData);
    document.dispatchEvent(customEvent);

    // Scroll to current variant media.
    // let headerSticky = document.querySelector(".header.is-sticky"),
    //   headerHeight = headerSticky ? headerSticky.offsetHeight : 0,
    //   firstMedia =
    //     gallery &&
    //     gallery.getAttribute("data-id") === "layout-1" &&
    //     firstSelected &&
    //     firstSelected.featured_media
    //       ? gallery.querySelector(
    //           '.media-preview-wrap[data-id="' +
    //             firstSelected.featured_media.id +
    //             '"]',
    //         )
    //       : false;

    // if (firstMedia && window.matchMedia("(min-width: 992px)").matches) {
    //   let img = firstMedia.querySelector("img");
    //   if (img) {
    //     img.onload = function () {
    //       window.scrollTo({
    //         top:
    //           firstMedia.getBoundingClientRect().top +
    //           window.pageYOffset -
    //           headerHeight,
    //         behavior: "smooth",
    //       });
    //     };
    //   } else {
    //     window.scrollTo({
    //       top:
    //         firstMedia.getBoundingClientRect().top +
    //         window.pageYOffset -
    //         headerHeight,
    //       behavior: "smooth",
    //     });
    //   }
    // }
  });
}

// Quick view variant options.
function btyQuickViewVariants(doc = document) {
  let selector = doc.querySelector(".product-variants");
  if (!selector) {
    return;
  }

  let variants = selector.parentNode.querySelector("[data-product-variants]"),
    quantity = selector.parentNode.querySelector("[data-inventory-quantity]"),
    field = selector.querySelectorAll(".field-value");
  if (!field.length || !variants) {
    return;
  }

  let summary = selector.parentNode,
    variant_pick = {};

  variants = btyJsonParse(variants.textContent);
  quantity = btyJsonParse(quantity.textContent);

  field.forEach(function (el) {
    if ("radio" === el.type) {
      if (el.checked) {
        variant_pick[el.name] = el.value;
      }
    } else {
      variant_pick[el.name] = el.value;
    }

    el.onchange = function () {
      variant_pick[el.name] = el.value;

      // Update stock status.
      btyUpdateStockStatusProduct(variants, selector);

      // When variant change.
      let selected = btySelectedVariant(variant_pick, variants),
        price = summary.querySelector(".product-price"),
        labeled = el.parentNode.querySelector(".selected-value"),
        form = summary.querySelector('[data-type="add-to-cart-form"]'),
        input = form ? form.querySelector(".quantity-input") : false,
        productId = form ? form.querySelector('[name="id"]') : false,
        button = form ? form.querySelector('[name="add"]') : false,
        productLink = summary.querySelector(".product-url"),
        productUrl = selector ? selector.getAttribute("data-url") : false,
        amount = summary.querySelector(".product-sale-label .sale-total"),
        shareInput = summary.querySelector(".product-share .field-input");

      // Check variant selling plan.
      if (form) {
        let sellingMessage = form.parentNode.querySelector(
          ".selling-plan-message",
        );

        if (sellingMessage && !sellingMessage.classList.contains("hidden")) {
          sellingMessage.innerHTML = "";
          sellingMessage.classList.add("hidden");
        }
      }

      // Update product url.
      if (productUrl) {
        if (productLink) {
          productLink.href = productUrl + "?variant=" + selected.id;
        }

        if (shareInput) {
          shareInput.value =
            window.location.origin + productUrl + "?variant=" + selected.id;
        }
      }

      // Current swatch label.
      let currentSwatch = el
        .closest(".variant-field")
        .querySelector(".field-title .selected-value");
      if (currentSwatch) {
        currentSwatch.innerText = el.value.trim();
      }

      // Update price.
      if (price) {
        price.innerHTML = btyPriceHtml(
          selected.price,
          selected.compare_at_price,
          selected.unit_price,
          selected.unit_price_measurement,
        );
      }

      // Update selected value.
      if (labeled) {
        labeled.innerHTML = el.value;
      }

      // Update sale number badge.
      if (amount) {
        if (selected.compare_at_price) {
          let amountTotal =
            (100 * (selected.compare_at_price - selected.price)) /
            selected.compare_at_price;

          amount.innerHTML = Math.round(amountTotal) + "%";

          amount.parentNode.classList.remove("hidden");
        } else {
          amount.parentNode.classList.add("hidden");
        }
      }

      // Update product variant ID.
      if (productId) {
        productId.value = selected.id;
      }

      // Set max quantity.
      if (input) {
        let max = quantity.filter(function (e) {
          return e.id === selected.id;
        });
        if (max.length) {
          let qty = max[0].qty;

          if (qty > 0) {
            if (Number(input.value) > qty) {
              input.value = qty;
            }

            input.setAttribute("max", qty);
          } else {
            input.removeAttribute("max");
          }
        } else {
          input.removeAttribute("max");
        }
      }

      // Update form state.
      if (form) {
        if (selected.available) {
          form.classList.remove("disabled");
        } else {
          form.classList.add("disabled");
        }
      }

      // Update add to cart button text.
      if (button) {
        if (selected.available) {
          button.innerHTML = btyStrings.product.add_to_cart;
        } else {
          button.innerHTML = btyStrings.product.out_of_stock;
        }
      }

      const customData = {
        detail: {
          selected: selected,
        },
      };

      const customEvent = new CustomEvent("product-quick-viewed", customData);
      document.dispatchEvent(customEvent);
    };
  });

  // For first load.
  btySelectedVariant(variant_pick, variants);
}

// Quick view.
function btyQuickView(doc = document) {
  let box = document.querySelector(".quick-view"),
    content = box ? box.querySelector(".quick-view-content") : false,
    selector = doc.querySelectorAll(".product-quick-view");
  if (!content || !selector.length) {
    return;
  }

  selector.forEach(function (el) {
    el.onclick = function (e) {
      e.preventDefault();

      // Save the element that opens the popup.
      box.triggerElement = el;

      let product_id = el.parentNode.getAttribute("data-id");
      if (product_id == box.getAttribute("data-id")) {
        document.documentElement.classList.add("quick-view-open");
        return;
      }

      document.documentElement.classList.add("quick-view-open");
      box.classList.add("loading");
      box.setAttribute("data-id", product_id);

      fetch(el.href + "?sections=quickview")
        .then(function (r) {
          if (200 !== r.status) {
            console.log("Status Code: " + r.status);
            throw r;
          }

          return r.json();
        })
        .then(function (res) {
          content.innerHTML = btyGetSectionHtml(res.quickview);

          btyQuickViewVariants(box, {});
        })
        .catch(function (e) {
          console.error(e);
        })
        .finally(function () {
          // Re-init share.
          btyProductShare();

          // Re-init quantity.
          btyQuantityButton();

          // Update lazy load image.
          btyAnimationImageLoad(box, 0);

          // Re-init add to cart.
          btyAddToCart();

          // Remove loading.
          box.classList.remove("loading");

          // Close popup.
          btyClosePopup("quick-view-open", box);

          let closeButton = box.querySelector(".quick-view-close");
          if (closeButton) {
            closeButton.focus();
          }

          btyTrapFocus(box, closeButton);
        });
    };
  });
}

// Update storage.
function btyUpdateStorage(key, array, id, type = "local") {
  let storage = "local" === type ? localStorage : sessionStorage;

  if (!storage.getItem(key)) {
    // Set key.
    storage.setItem(key, JSON.stringify(array));
  } else if (!storage.getItem(key).includes(id)) {
    // Add new id.
    let parseStorage = btyJsonParse(storage.getItem(key));
    if (!parseStorage) {
      return;
    }

    parseStorage.push(id);

    storage.setItem(key, JSON.stringify(parseStorage));
  }
}

// Update variants on popup.
function btyVariantsPopup(doc = document, popup) {
  let variants = doc.querySelectorAll(".product-variants");
  if (!popup || !variants.length) {
    return;
  }

  variants.forEach(function (el) {
    let variantData = el.querySelector("[data-product-variants]"),
      productId = el.getAttribute("data-id"),
      select = el.querySelectorAll(".field-value"),
      imageLink = popup.querySelector(
        '.preview-image [data-id="' + productId + '"]',
      ),
      image = imageLink ? imageLink.querySelector("img") : false,
      price = popup.querySelector(
        '[data-id="' + productId + '"] .product-price',
      ),
      stock = popup.querySelector(
        '[data-id="' + productId + '"] .product-stock-status',
      ),
      form = popup.querySelector(
        '.form-add-to-cart[data-id="' + productId + '"]',
      ),
      inputId = form ? form.querySelector('[name="id"]') : false,
      variantPick = {};

    if (!select.length) {
      return;
    }

    variantData = variantData ? btyJsonParse(variantData.textContent) : false;
    if (!variantData) {
      return;
    }

    // Foreach.
    select.forEach(function (sel) {
      variantPick[sel.name] = sel.value;

      // Change event.
      sel.onchange = function () {
        variantPick[sel.name] = sel.value;

        let selected = btySelectedVariant(variantPick, variantData);

        // Update image.
        if (image) {
          image.removeAttribute("srcset");
          btyImageLoad(
            image,
            selected.featured_media.preview_image.src,
            selected.featured_media.id,
            image.parentNode,
          );
        }

        // Update current variant id.
        if (inputId) {
          inputId.value = selected.id;
        }

        // Update stock status, add to cart button text.
        if (selected.available) {
          if (form) {
            form.classList.remove("disabled");
          }

          if (stock) {
            stock.innerHTML = btyStrings.product.in_stock;
            stock.classList.remove("inventory--low");
            stock.classList.add("inventory--high");
          }
        } else {
          if (form) {
            form.classList.add("disabled");
          }

          if (stock) {
            stock.innerHTML = btyStrings.product.out_of_stock;
            stock.classList.remove("inventory--high");
            stock.classList.add("inventory--low");
          }
        }

        // Update price.
        if (price) {
          price.innerHTML = btyPriceHtml(
            selected.price,
            selected.compare_at_price,
          );
        }
      };
    });

    // First matching variants.
    let firstSelected = btySelectedVariant(variantPick, variantData);
    if (firstSelected.available) {
      if (form) {
        form.classList.remove("disabled");
      }

      if (stock) {
        stock.innerHTML = btyStrings.product.in_stock;
        stock.classList.remove("inventory--low");
        stock.classList.add("inventory--high");
      }
    } else {
      if (form) {
        form.classList.add("disabled");
      }

      if (stock) {
        stock.innerHTML = btyStrings.product.out_of_stock;
        stock.classList.remove("inventory--high");
        stock.classList.add("inventory--low");
      }
    }

    if (price) {
      price.innerHTML = btyPriceHtml(
        firstSelected.price,
        firstSelected.compare_at_price,
      );
    }
  });
}

// Open side cart.
function btySideCart() {
  let buttons = document.querySelectorAll(".action-cart"),
    sideCart = document.querySelector(".side-cart");
  if (!buttons.length || !sideCart) {
    return;
  }

  buttons.forEach(function (el) {
    el.onclick = function (e) {
      e.preventDefault();

      // Save the element that opens the popup.
      sideCart.triggerElement = el;

      document.documentElement.classList.add("side-cart-open");

      btyClosePopup("side-cart-open", sideCart);

      let closeButton = sideCart.querySelector(".side-cart-close");
      if (closeButton) {
        setTimeout(function () {
          closeButton.focus();
        }, 400);
      }

      btyTrapFocus(sideCart, closeButton);
    };
  });
}

// Get fetch config.
function btyFetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/" + type,
    },
  };
}

// ValidateEmail.
function btyValidateEmail(selector, focus = true) {
  if (!selector || selector.disabled) {
    return;
  }

  let mailformat =
    /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

  if (selector.value.match(mailformat)) {
    selector.classList.remove("email-invalid");
  } else {
    selector.classList.add("email-invalid");

    if (focus) {
      selector.focus();
    }
  }
}

// Recipient form.
function btyRecipientForm(doc = document) {
  let wrapper = doc.querySelector(".recipient-form-wrapper"),
    input = wrapper
      ? wrapper.querySelector(
          '.recipient-checkbox-label input[type="checkbox"]',
        )
      : false,
    fields = wrapper ? wrapper.querySelector(".recipient-fields") : false;

  if (!input || !fields) {
    return;
  }

  let hiddenControlField = fields.parentNode.querySelector(
      '[type="hidden"][name="properties[__shopify_send_gift_card_to_recipient]"]',
    ),
    offsetProperty = fields.parentNode.querySelector(
      '[name="properties[__shopify_offset]"]',
    );
  if (hiddenControlField) {
    hiddenControlField.disabled = true;
  }

  if (offsetProperty) {
    offsetProperty.value = new Date().getTimezoneOffset().toString();
  }

  let inputFields = fields.parentNode.querySelectorAll(".field__input");
  if (!inputFields.length) {
    return;
  }

  function init() {
    if (input.checked) {
      fields.classList.add("open");

      inputFields.forEach(function (el) {
        el.disabled = false;
      });
    } else {
      fields.classList.remove("open");

      inputFields.forEach(function (el) {
        el.disabled = true;
      });

      let emailInput = fields.querySelector(".properties-recipient-email"),
        message =
          wrapper.parentNode.parentNode.querySelector(".product-warning");

      if (emailInput) {
        emailInput.classList.remove("email-invalid");
      }

      if (message) {
        message.innerHTML = "";
      }
    }
  }

  input.onchange = init;
  init();
}

// Ajax add to cart.
function btyAddToCart(doc = document) {
  let buttons = doc.querySelectorAll(".add-to-cart-button");
  if (!buttons.length) {
    return;
  }

  // Register dom html need an update when the response available.
  let modules = [
    {
      node: ".side-cart-inner", // DOM html selector.
      section: "side-cart", // Section name.
      selector: ".side-cart-inner", // Ajax response selector.
    },
    {
      section: "cart-count",
    },
  ];

  buttons.forEach(function (button) {
    let form = button.closest('[data-type="add-to-cart-form"]');

    // Hidden payment button if require selling plan.
    if (button.classList.contains("selling-plan-error")) {
      if (form) {
        let paymentButton = form.querySelector(".shopify-payment-button");

        if (paymentButton) {
          paymentButton.classList.add("hidden");
        }
      }
    }

    button.onclick = function (e) {
      // Check add product selling plan.
      if (button.classList.contains("selling-plan-error")) {
        let sellingMessage = form.parentNode.querySelector(
          ".selling-plan-message",
        );

        if (sellingMessage) {
          sellingMessage.innerHTML = btyStrings.product.selling_plan_message;
          sellingMessage.classList.remove("hidden");
        }

        e.preventDefault();

        return;
      }

      // Return user click Tab button then Enter.
      if (button.classList.contains("disabled")) {
        e.preventDefault();

        return;
      }

      if ("A" === button.tagName.toUpperCase()) {
        return;
      }

      e.preventDefault();

      if (
        button.classList.contains("add-product-variants") &&
        window.matchMedia("(max-width: 767px)").matches
      ) {
        return;
      }

      button.classList.add("loading");

      let formData = new FormData(form),
        warning = form.parentNode.querySelector(".product-warning"),
        config = btyFetchConfig("javascript");

      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      formData.append(
        "sections",
        modules.map((s) => s.section),
      );
      formData.append("sections_url", window.location.pathname);
      config.body = formData;

      // Fetch data.
      fetch(btyGlobals.cart_add_url, config)
        .then(function (r) {
          return r.json();
        })
        .then(function (res) {
          // Check recipient form.
          let recipientForm = form.querySelector(".recipient-form");

          if (recipientForm) {
            let inputEmail = recipientForm.querySelector(
                '[name="properties[Recipient email]"]',
              ),
              inputSendOn = recipientForm.querySelector(
                '[name="properties[Send on]"]',
              );

            if (res && res.errors) {
              if (inputEmail) {
                let emailField = inputEmail.closest(".recipient-fields__field"),
                  emailMessage = emailField
                    ? emailField.querySelector(".form__message")
                    : null;

                if (
                  Array.isArray(res.errors.email) &&
                  res.errors.email.length > 0
                ) {
                  inputEmail.setAttribute("aria-invalid", true);

                  if (emailMessage) {
                    emailMessage.classList.remove("hidden");
                    let emailMessageText = emailMessage.querySelector(
                      ".error-message-text",
                    );
                    if (emailMessageText) {
                      emailMessageText.innerHTML = res.errors.email[0];
                    }
                  }
                } else {
                  inputEmail.removeAttribute("aria-invalid");

                  if (emailMessage) {
                    emailMessage.classList.add("hidden");
                    let emailMessageText = emailMessage.querySelector(
                      ".error-message-text",
                    );
                    if (emailMessageText) {
                      emailMessageText.innerHTML = "";
                    }
                  }
                }
              }

              if (inputSendOn) {
                let sendOnField = inputSendOn.closest(
                    ".recipient-fields__field",
                  ),
                  sendOnMessage = sendOnField
                    ? sendOnField.querySelector(".form__message")
                    : null;

                if (
                  Array.isArray(res.errors.send_on) &&
                  res.errors.send_on.length > 0
                ) {
                  inputSendOn.setAttribute("aria-invalid", true);

                  if (sendOnMessage) {
                    sendOnMessage.classList.remove("hidden");
                    let sendOnMessageText = sendOnMessage.querySelector(
                      ".error-message-text",
                    );
                    if (sendOnMessageText) {
                      sendOnMessageText.innerHTML = res.errors.send_on[0];
                    }
                  }
                } else {
                  inputSendOn.removeAttribute("aria-invalid");

                  if (sendOnMessage) {
                    sendOnMessage.classList.add("hidden");
                    let sendOnMessageText = sendOnMessage.querySelector(
                      ".error-message-text",
                    );
                    if (sendOnMessageText) {
                      sendOnMessageText.innerHTML = "";
                    }
                  }
                }
              }
            } else {
              [inputEmail, inputSendOn].forEach(function (input) {
                if (input) {
                  input.removeAttribute("aria-invalid");
                  let field = input.closest(".recipient-fields__field");

                  let message = field
                    ? field.querySelector(".form__message")
                    : null;
                  if (message) {
                    message.classList.add("hidden");

                    let messageText = message.querySelector(
                      ".error-message-text",
                    );

                    if (messageText) {
                      messageText.innerHTML = "";
                    }
                  }
                }
              });
            }
          }

          if (warning) {
            warning.innerHTML = res.status
              ? btyGlobals.svg_warning + res.description
              : "";
          }

          if (res.status) {
            form.dispatchEvent(new CustomEvent("bjp:cart-error", { bubbles: true, detail: { message: res.description } }));
            return;
          }

          // Update html.
          btyUpdateHtml(res.sections, modules);

          // Re-init cart popup outer.
          btySideCartPopupOuter();

          // Update cart items count.
          btyCartItemCount(
            btyGetSectionHtml(res.sections["cart-count"], ".shopify-section"),
          );

          setTimeout(function () {
            // Show side cart.
            document.documentElement.classList.add("side-cart-open");
          });

          // Update cart progress bar.
          btyUpdateProgressBarCart(res.total_price);
          form.dispatchEvent(new CustomEvent("bjp:cart-added", { bubbles: true }));
        })
        .catch(function (e) {
          console.error(e);
          form.dispatchEvent(new CustomEvent("bjp:cart-error", { bubbles: true }));
        })
        .finally(function () {
          // Re-init quantity.
          btyQuantityButton();

          // Re-init update quantity button.
          btyUpdateProductQuantity();

          // Remove loading animation.
          button.classList.remove("loading");
          form.dispatchEvent(new CustomEvent("bjp:cart-idle", { bubbles: true }));

          // Remove loading animation for quick add.
          let quickAddLoading = doc.querySelector(
            ".quick-add-box .field-item.loading",
          );
          if (quickAddLoading) {
            quickAddLoading.classList.remove("loading");
          }

          document.documentElement.classList.remove("quick-view-open");
          btyClosePopup("side-cart-open", document.querySelector(".side-cart"));

          // Focus cart drawer.
          let sideCart = document.querySelector(".side-cart"),
            closeButton = sideCart
              ? sideCart.querySelector(".side-cart-close")
              : false;
          if (closeButton) {
            setTimeout(function () {
              closeButton.focus();
            }, 400);
          }

          // Reinit checkbox agree to terms.
          btyAgreeToTerms();
        });
    };
  });
}

// Ajax add all set to cart.
function btyAddMultiProductToCart(doc = document) {
  let selectors = doc.querySelectorAll(".add-multiple-products");
  if (!selectors.length) {
    return;
  }

  selectors.forEach(function (el) {
    let items = el.parentNode.querySelectorAll('.product-card [name="id"]');
    if (!items.length) {
      return;
    }

    items.forEach(function (item, index) {
      item.addEventListener("change", function () {
        let currentId = el.querySelector('[data-index="' + index + '"]');
        if (currentId) {
          currentId.value = item.value;
        }
      });
    });
  });
}

// Check product inventory.
function btyProductInventory(doc = document, variants = {}) {
  let variant = {},
    quickAdds = doc.querySelectorAll(".quick-add-box .field-swatch .selected"),
    swatches = doc.querySelector(".product-swatches .selected");
  if (!quickAdds.length && !swatches) {
    return;
  }

  let selected = btySelectedVariant(variant, variants);
}

/**
 * Update stock status
 *
 * @param  object variants The product variants.
 * @param  node   siblings The product card.
 */
function btyUpdateStockStatus(variants, card) {
  let getSelected = card.querySelectorAll(".field-swatch .selected"),
    swatch = card.querySelector(".product-swatches .swatch.selected");
  if (getSelected.length) {
    getSelected.forEach(function (el) {
      let current = {};

      // Check color variant.
      if (swatch) {
        current[swatch.getAttribute("data-name")] =
          swatch.getAttribute("data-value");
      }

      // Get siblings to save 2 fix variant, ex: ABC ABD ABX ABY.
      let siblings = btySiblings(el.parentNode, function (e) {
        return e.classList.contains("field-swatch");
      });

      if (siblings.length) {
        siblings.forEach(function (si) {
          let siSelected = si.querySelector(".selected");
          if (!siSelected) {
            return;
          }

          current[siSelected.getAttribute("data-name")] =
            siSelected.getAttribute("data-value");
        });
      }

      // Update stock status on quick add.
      let indexSelected = el.parentNode.querySelectorAll(".field-item");
      if (indexSelected.length) {
        indexSelected.forEach(function (is) {
          current[is.getAttribute("data-name")] = is.getAttribute("data-value");

          let selected = btySelectedVariant(current, variants);
          if (selected) {
            if (selected.available) {
              is.classList.remove("soldout");
            } else {
              is.classList.add("soldout");
            }
          } else {
            is.classList.add("soldout");
          }
        });
      }
    });
  }

  if (swatch) {
    swatch.parentNode.querySelectorAll(".swatch").forEach(function (el) {
      let current = {};

      if (getSelected.length) {
        getSelected.forEach(function (si) {
          current[si.getAttribute("data-name")] = si.getAttribute("data-value");
        });
      }

      current[el.getAttribute("data-name")] = el.getAttribute("data-value");

      let selected = btySelectedVariant(current, variants);
      if (selected) {
        if (selected.available) {
          el.classList.remove("soldout");
        } else {
          el.classList.add("soldout");
        }
      } else {
        el.classList.add("soldout");
      }
    });
  }
}

/**
 * Update stock status for product page
 *
 * @param  object variants The product variants.
 * @param  node   siblings The product card.
 */
function btyUpdateStockStatusProduct(variants, element) {
  let getSelected = element.querySelectorAll(
    ".variant-field .field-value:checked",
  );
  if (!getSelected.length) {
    return;
  }

  getSelected.forEach(function (el) {
    let current = {};

    // Get siblings to save 2 fix variant, ex: ABC ABD ABX ABY.
    let siblings = btySiblings(el.closest(".variant-field"), function (e) {
      return e.classList.contains("variant-field");
    });

    if (siblings.length) {
      siblings.forEach(function (si) {
        let siSelected = si.querySelector(".field-value:checked");
        if (!siSelected) {
          return;
        }

        current[siSelected.getAttribute("name")] =
          siSelected.getAttribute("value");
      });
    }

    // Update stock status on quick add.
    let indexSelected = el
      .closest(".variant-field")
      .querySelectorAll(".field-value");
    if (indexSelected.length) {
      indexSelected.forEach(function (is) {
        let inputId = is.getAttribute("id"),
          label = inputId
            ? is.parentNode.querySelector('label[for="' + inputId + '"]')
            : false;

        if (!label) {
          return;
        }

        current[is.getAttribute("name")] = is.getAttribute("value");

        let selected = btySelectedVariant(current, variants);
        if (selected) {
          if (selected.available) {
            label.classList.remove("soldout");
          } else {
            label.classList.add("soldout");
          }
        } else {
          label.classList.add("soldout");
        }
      });
    }
  });
}

// Quick add.
function btyQuickAdd(doc = document) {
  let selectors = doc.querySelectorAll(".quick-add .field-item");
  if (!selectors.length) {
    return;
  }

  selectors.forEach(function (el) {
    function handleSelection(event) {
      if (
        event.type === "click" ||
        (event.type === "keydown" &&
          (event.key === "Enter" || event.keyCode === 13))
      ) {
        let form = el.closest('[data-type="add-to-cart-form"]'),
          submit = form ? form.querySelector('[type="submit"]') : false,
          card = form.closest(".product-card");
        if (!card || !submit) {
          return;
        }

        // Highlight selected.
        if (!el.classList.contains("selected")) {
          let oldActive = el.parentNode.querySelector(".field-item.selected");
          if (oldActive) {
            oldActive.classList.remove("selected");
          }

          el.classList.add("selected");
        }

        // Update swatch.
        let variants = form.querySelector("[data-product-variants]"),
          productId = form.querySelector('[name="id"]');

        if (productId && variants) {
          // Json parse.
          variants = btyJsonParse(variants.textContent);

          let variant_pick = {},
            quickAddSelected = card.querySelectorAll(
              ".quick-add-box .selected",
            );

          if (quickAddSelected.length) {
            quickAddSelected.forEach(function (qas) {
              variant_pick[qas.getAttribute("data-name")] =
                qas.getAttribute("data-value");
            });
          }

          // Get option from Swatch.
          let selectedSwatch = card.querySelector(
            ".product-swatches .swatch.selected",
          );
          if (selectedSwatch) {
            variant_pick[selectedSwatch.getAttribute("data-name")] =
              selectedSwatch.getAttribute("data-value");
          }

          // Found selected variant.
          let selected = btySelectedVariant(variant_pick, variants);
          if (selected) {
            productId.value = selected.id;

            // Update stock status.
            btyUpdateStockStatus(variants, card);

            // Update product price.
            let price = card.querySelector(".product-price");
            if (price) {
              price.innerHTML = btyPriceHtml(
                selected.price,
                selected.compare_at_price,
                selected.unit_price,
                selected.unit_price_measurement,
              );
            }

            if (selected.available) {
              el.classList.add("loading");

              submit.click();
            } else {
              alert("This item is currently out of stock.");

              return;
            }
          }
        }
      }
    }

    el.addEventListener("click", handleSelection);
    el.addEventListener("keydown", handleSelection);
  });
}

// Swatch list.
function btySwatch(doc = document) {
  let swatch = doc.querySelectorAll(".product-card .swatch");
  if (!swatch.length) {
    return;
  }

  swatch.forEach(function (el) {
    el.onmouseenter = function (e) {
      e.preventDefault();

      if (el.classList.contains("selected")) {
        return;
      }

      let swatchValue = el.parentNode.querySelector(".swatch-selected");
      if (swatchValue) {
        swatchValue.innerText = el.innerText.trim();
      }

      // Get wrapper.
      let card = el.closest(".product-card"),
        wrapper = card.querySelector(".product-media-wrap");
      if (!wrapper) {
        return;
      }

      // Get product image.
      let image = wrapper.querySelector(".product-image img");

      // Cache default (main) image once per card so we can return to it later
      if (image && !image.dataset.defaultSrc) {
        image.dataset.defaultSrc = image.currentSrc || image.src;
      }

      // Handle loading image.
      const imageLoadHandle = function (dataSrc, main) {
        if (!image) {
          return;
        }

        let newImage = new Image(),
          variationImg = el.getAttribute("data-key") || false,
          mainImg = image.getAttribute("data-key") || false;

        newImage.crossOrigin = "anonymous";

        // Main image.
        if (main) {
          variationImg = mainImg;
        }

        // Check local storage first.
        if (sessionStorage.getItem(variationImg)) {
          image.src = sessionStorage.getItem(variationImg);
          image.removeAttribute("srcset");
          return;
        }

        // Save main product image first.
        if ("string" !== typeof image.getAttribute("data-loaded") && mainImg) {
          let mainImage = new Image();

          mainImage.crossOrigin = "anonymous";

          mainImage.onload = function () {
            let renderMainImage = btyGetImageSrc(mainImage);

            if (mainImg) {
              sessionStorage.setItem(mainImg, renderMainImage);
            }

            image.setAttribute("data-loaded", "");
          };

          mainImage.src = image.src;
        }

        // Add loading animation.
        wrapper.classList.add("loading");

        // Handle.
        newImage.onload = function () {
          wrapper.classList.remove("loading");
          let renderImage = btyGetImageSrc(newImage);

          // Set final image src.
          image.src = renderImage;
          image.removeAttribute("srcset");

          // Save image to local storage.
          if (variationImg) {
            sessionStorage.setItem(variationImg, renderImage);
          }
        };

        newImage.onerror = function () {
          wrapper.classList.remove("loading");

           // Fallback to default image if variant failed to load
          if (!main && image && image.dataset && image.dataset.defaultSrc) {
            imageLoadHandle(image.dataset.defaultSrc, true);
          }
        };

        // Set image src for 'newImage.onload' function handle.
        newImage.src = dataSrc;
      };

      // Get old selected.
      let oldActive = card.querySelector(".swatch.selected");
      if (oldActive) {
        oldActive.classList.remove("selected");
      }

      // Set swatch selected.
      el.classList.add("selected");

      // Update product image src.
      if (image) {
        const src = el.getAttribute("data-src") || "";
        const defaultSrc = image.dataset.defaultSrc || image.src; // safety

        if (src) {
          if (src !== image.src) {
            imageLoadHandle(src); // normal variant image
          }
        } else if (defaultSrc && defaultSrc !== image.src) {
          imageLoadHandle(defaultSrc, true); // fallback to main
        }
      }

      // Update swatch.
      let form = el
          .closest(".product-card")
          .querySelector('[data-type="add-to-cart-form"]'),
        addToCart = form ? form.querySelector(".add-to-cart-button") : false,
        variants = form ? form.querySelector("[data-product-variants]") : false,
        productId = form ? form.querySelector('[name="id"]') : false;

      if (productId && variants) {
        let variant_pick = {},
          dataName = el.getAttribute("data-name"),
          dataValue = el.getAttribute("data-value");

        variants = btyJsonParse(variants.textContent);

        variant_pick[dataName] = dataValue;

        // Update stock status.
        btyUpdateStockStatus(variants, card);

        // Get quick add value.
        let quickAdd = card.querySelectorAll(".quick-add .field-item.selected");
        if (quickAdd.length) {
          quickAdd.forEach(function (qa) {
            variant_pick[qa.getAttribute("data-name")] =
              qa.getAttribute("data-value");
          });
        }

        let selected = btySelectedVariant(variant_pick, variants);
        if (selected) {
          productId.value = selected.id;

          // Dispatch 'change' event.
          productId.dispatchEvent(new Event("change"));

          // Update add to cart button status.
          if (addToCart) {
            if (selected.available) {
              addToCart.classList.remove("disabled");
            } else {
              addToCart.classList.add("disabled");
            }
          }
        }
      }
    };
  });
}

// Product tabs.
function btyProductTabs(doc = document, event = {}) {
  let selectors = doc.querySelectorAll(".tabs .tab-head");
  if (!selectors.length) {
    return;
  }

  selectors.forEach(function (el) {
    let wrap = el.closest(".tabs"),
      index = el.getAttribute("data-index"),
      tab = wrap.querySelector('.tab-content[data-index="' + index + '"]');

    if (!tab) {
      return;
    }

    // For design mode.
    if (Shopify.designMode && Object.keys(event).length) {
      let currentTab = doc.querySelector(
        '.tab-head[data-id="' + event.detail.blockId + '"]',
      );
      if (currentTab) {
        currentTab.click();
      }
    }

    el.addEventListener("click", function () {
      if (el.classList.contains("active")) {
        return;
      }

      let navActived = wrap.querySelector(".tab-head.active"),
        tabActived = wrap.querySelector(".tab-content.active");
      if (navActived) {
        navActived.classList.remove("active");
      }

      if (tabActived) {
        tabActived.classList.remove("active");
      }

      el.classList.add("active");
      tab.classList.add("active");
    });
  });

  let dropdown = doc.querySelectorAll(".dropdown-content li");
  if (dropdown.length) {
    dropdown.forEach(function (el) {
      el.addEventListener("click", function () {
        let parent = el.closest(".tabs"),
          current = parent.querySelector(
            '.tab-head[data-index="' + el.getAttribute("data-index") + '"]',
          );
        if (!current) {
          return;
        }

        current.click();
      });
    });
  }
}

// Video.
function btyVideo(doc = document) {
  let selectors = doc.querySelectorAll(".video-item");
  if (!selectors.length) {
    return;
  }

  selectors.forEach(function (el) {
    let imageWrapper = el.querySelector(".video-image-wrapper");

    if (!imageWrapper) {
      return;
    }

    imageWrapper.addEventListener("click", function () {
      let iframe = el.querySelector("iframe"),
        video = el.querySelector("video");

      if (iframe) {
        iframe.src = iframe.getAttribute("data-src");

        btyMediaAction(el, "play");
      }

      if (video) {
        video.setAttribute("data-ready", "");

        let playPromise = video.play();
        if (undefined !== playPromise) {
          playPromise
            .then(function () {})
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    });
  });
}

class VideoSection extends HTMLElement {
  constructor() {
    super();

    this.background = true;

    this.init();
  }

  init() {
    this.parentSelector = this.dataset.parent || ".background-video-item";
    this.parent = this.closest(this.parentSelector);

    switch (this.dataset.type) {
      case "youtube":
        this.initYoutubeVideo();
        break;

      case "vimeo":
        this.initVimeoVideo();
        break;

      case "mp4":
        this.initMp4Video();
        break;
    }
  }

  initYoutubeVideo() {
    this.setAsLoading();
    this.loadScript("youtube").then(this.setupYoutubePlayer.bind(this));
  }

  initVimeoVideo() {
    this.setAsLoading();
    this.loadScript("vimeo").then(this.setupVimeoPlayer.bind(this));
  }

  initMp4Video() {
    const player = this.querySelector("video");

    if (player) {
      const promise = player.play();

      // Edge does not return a promise (video still plays)
      if (typeof promise !== "undefined") {
        promise
          .then(function () {
            // playback normal
          })
          .catch(function () {
            player.setAttribute("controls", "");
          });
      }
    }
  }

  loadScript(videoType) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src =
        videoType === "youtube"
          ? "//www.youtube.com/iframe_api"
          : "//player.vimeo.com/api/player.js";
    });
  }

  setAsLoading() {
    this.parent.setAttribute("loading", true);
  }

  setAsLoaded() {
    this.parent.removeAttribute("loading");
    this.parent.setAttribute("loaded", true);
  }

  setupYoutubePlayer() {
    const videoId = this.dataset.videoId;

    const playerInterval = setInterval(() => {
      if (window.YT) {
        window.YT.ready(() => {
          const element = document.createElement("div");
          this.appendChild(element);

          this.player = new YT.Player(element, {
            videoId: videoId,
            playerVars: {
              showinfo: 0,
              controls: !this.background,
              fs: !this.background,
              rel: 0,
              height: "100%",
              width: "100%",
              iv_load_policy: 3,
              html5: 1,
              loop: 1,
              playsinline: 1,
              modestbranding: 1,
              disablekb: 1,
              mute: 1,
            },
            events: {
              onReady: this.onYoutubeReady.bind(this),
              onStateChange: this.onYoutubeStateChange.bind(this),
            },
          });
          clearInterval(playerInterval);
        });
      }
    }, 50);
  }

  onYoutubeReady() {
    // iframe once YT loads.
    this.iframe = this.querySelector("iframe");
    this.iframe.setAttribute("tabindex", "-1");

    if (this.background) {
      this.player.mute() ? this.player.mute() : null;
    }

    if ("function" === typeof this.player.playVideo) {
      this.player.playVideo();
    }

    this.setAsLoaded();

    // pause when out of view
    const observer = new IntersectionObserver(
      (entries, _observer) => {
        entries.forEach((entry) => {
          entry.isIntersecting ? this.youtubePlay() : this.youtubePause();
        });
      },
      {
        rootMargin: "100px",
      },
    );

    observer.observe(this.iframe);
  }

  onYoutubeStateChange(event) {
    switch (event.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer
        if (this.attemptedToPlay) {
          this.setAsLoaded();
        }
        break;
      case 0: // ended, loop it
        this.youtubePlay();
        break;
      case 1: // playing
        this.setAsLoaded();
        break;
      case 3: // buffering
        this.attemptedToPlay = true;
        break;
    }
  }

  youtubePlay() {
    if (
      this.background &&
      this.player &&
      "function" === typeof this.player.playVideo
    ) {
      this.player.playVideo();
    }
  }

  youtubePause() {
    if (
      this.background &&
      this.player &&
      "function" === typeof this.player.playVideo
    ) {
      this.player.pauseVideo();
    }
  }

  setupVimeoPlayer() {
    const videoId = this.dataset.videoId;

    const playerInterval = setInterval(() => {
      if (window.Vimeo) {
        this.player = new Vimeo.Player(this, {
          id: videoId,
          autoplay: true,
          autopause: false,
          background: this.background,
          controls: !this.background,
          loop: true,
          height: "100%",
          width: "100%",
        });

        this.player.ready().then(this.onVimeoReady.bind(this));

        clearInterval(playerInterval);
      }
    }, 50);
  }

  onVimeoReady() {
    this.iframe = this.querySelector("iframe");
    this.iframe.setAttribute("tabindex", "-1");

    this.background && this.player.setMuted(true);

    this.setAsLoaded();

    // pause when out of view
    const observer = new IntersectionObserver(
      (entries, _observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.vimeoPlay();
          } else {
            this.vimeoPause();
          }
        });
      },
      { rootMargin: "0px 0px 50px 0px" },
    );

    observer.observe(this.iframe);
  }

  vimeoPlay() {
    if (
      this.background &&
      this.player &&
      "function" === typeof this.player.play
    ) {
      this.player.play();
    }
  }

  vimeoPause() {
    if (
      this.background &&
      this.player &&
      "function" === typeof this.player.play
    ) {
      this.player.pause();
    }
  }
}
customElements.define("strong-video", VideoSection);

// Video background.
function btyBackgroundVideo(doc = document) {
  let selectors = doc.querySelectorAll(".toggle-popup-bg-video");
  if (!selectors.length) {
    return;
  }

  selectors.forEach(function (el) {
    el.addEventListener("click", function () {
      let section = el.closest(".video-background-section"),
        popup = section
          ? section.querySelector(".background-video-popup")
          : false,
        iframe = popup ? popup.querySelector("iframe") : false,
        video = popup ? popup.querySelector("video") : false;

      if (!popup) {
        return;
      }

      document.documentElement.classList.add("bg-video-popup-open");
      btyClosePopup("bg-video-popup-open", popup);

      if (iframe) {
        iframe.src = iframe.getAttribute("data-src");

        btyMediaAction(popup, "play");
      }

      if (video) {
        video.setAttribute("data-ready", "");

        let playPromise = video.play();
        if (undefined !== playPromise) {
          playPromise
            .then(function () {})
            .catch(function (error) {
              console.log(error);
            });
        }
      }
    });
  });
}

// Action for media.
function btyMediaAction(doc = document, type = "pause") {
  let video = doc.querySelectorAll(".js-youtube, .js-vimeo, video");
  if (!video.length) {
    return;
  }

  let youtubeFunc = "stopVideo";

  switch (type) {
    case "pause":
      youtubeFunc = "pauseVideo";
      break;
    case "play":
      youtubeFunc = "playVideo";
      break;
    case "stop":
      youtubeFunc = "stopVideo";
      break;
  }

  if (video.length) {
    video.forEach(function (vd) {
      if ("video" === vd.tagName.toLowerCase()) {
        let playPromise = vd.play();

        if ("pause" === type) {
          if (undefined !== playPromise) {
            playPromise
              .then(function () {
                vd.pause();
              })
              .catch(function (error) {
                console.log(error);
              });
          }
        } else {
          if (undefined !== playPromise) {
            playPromise
              .then(function () {})
              .catch(function (error) {
                console.log(error);
              });
          }
        }
      } else if (vd.classList.contains("js-youtube")) {
        vd.contentWindow.postMessage(
          '{"event":"command","func":"' + youtubeFunc + '","args":""}',
          "*",
        );
      } else if (vd.classList.contains("js-vimeo")) {
        vd.contentWindow.postMessage('{"method":"' + type + '"}', "*");
      }
    });
  }
}

// Address box section.
function btyAddress(doc = document) {
  let selectors = doc.querySelectorAll(".address-box .address-summary");
  if (!selectors.length) {
    return;
  }

  selectors.forEach(function (el) {
    let items = el.querySelectorAll(".summary-item");
    if (items.length < 2) {
      return;
    }

    items.forEach(function (im, index) {
      im.addEventListener("click", function (e) {
        e.preventDefault();

        const mobile = window.matchMedia("(max-width: 767px)").matches;

        let oldActive = el.querySelector(".summary-item.active"),
          subBox = im.querySelector(".address-sub"),
          image = el.parentNode.querySelector(".address-content-inner");

        if (im.classList.contains("active")) {
          return;
        }

        if (oldActive) {
          let oldSubBox = oldActive.querySelector(".address-sub");
          if (oldSubBox && mobile) {
            btySlideUp(oldSubBox);
          }
          oldActive.classList.remove("active");
        }

        if (image) {
          image.setAttribute("data-level", index);
        }

        im.classList.add("active");

        if (subBox && mobile) {
          btySlideDown(subBox);
        }
      });
    });
  });
}

// Pickup availability.
function btyPickupAvailability(
  doc = document,
  variant_id = false,
  pickup = false,
) {
  let panel = document.querySelector(".pickup-availability-panel");
  if (!pickup || !panel) {
    return;
  }

  fetch("/variants/" + variant_id + "?section_id=pickup-availability")
    .then(function (r) {
      if (200 !== r.status) {
        console.log("Status Code: " + r.status);
        throw r;
      }

      return r.text();
    })
    .then(function (res) {
      pickup.innerHTML = btyGetSectionHtml(
        res,
        ".pickup-availability-info",
        "outer",
      );
      panel.innerHTML = btyGetSectionHtml(
        res,
        ".pickup-availability-modal",
        "outer",
      );

      let toggle = pickup.querySelector(".toggle-modal");
      if (toggle) {
        toggle.onclick = function () {
          document.documentElement.classList.add("pickup-availability-open");

          btyClosePopup("pickup-availability-open", panel);
        };
      }
    })
    .catch(function (e) {
      console.error(e);
    });
}

// Pickup availability for simple product.
function btyPickupAvailabilityInit(doc = document) {
  let variants = doc.querySelectorAll(".product-variants");
  if (variants.length) {
    return;
  }

  let inner = doc.querySelector(".product-summary-inner[data-selected-id]"),
    pickup = doc.querySelector(".pickup-availability"),
    productId = inner ? inner.getAttribute("data-selected-id") : false;

  if (!pickup || !productId) {
    return;
  }

  btyPickupAvailability(doc, productId, pickup);
}

// Popup content.
function btyProductPopup(doc = document) {
  let selectors = doc.querySelectorAll(".product-popup");
  if (!selectors.length) {
    return;
  }

  selectors.forEach(function (el) {
    let summary = el.closest(".product-summary"),
      button = el.querySelector(".popup-toggle"),
      view = el.querySelector(".popup-view"),
      close = el.querySelector(".popup-close");
    if (!summary || !button || !view || !close) {
      return;
    }

    button.onclick = function () {
      summary.classList.add("open");

      // Target.
      view.onclick = function (e) {
        if (view !== e.target) {
          return;
        }

        summary.classList.remove("open");
      };

      // Use ESC key.
      document.addEventListener("keyup", function (e) {
        if (27 !== e.keyCode) {
          return;
        }

        summary.classList.remove("open");
      });

      // Use close button.
      close.onclick = function () {
        summary.classList.remove("open");
      };
    };
  });
}

// Share button.
function btyProductShare(doc = document) {
  let selector = doc.querySelector(".product-share[data-os]");
  if (!selector) {
    return;
  }

  let button = selector.querySelector(".share-button"),
    summary = selector.querySelector("summary"),
    input = selector.querySelector(".field-input"),
    message = selector.querySelector(".share-message"),
    copy = selector.querySelector(".share-button-copy"),
    close = selector.querySelector(".share-button-close");

  if (!button || !summary || !copy || !close) {
    return;
  }

  let closeAction = function () {
    summary.parentNode.removeAttribute("open");
    close.classList.add("hidden");
    message.classList.add("hidden");
    message.textContent = "";
  };

  if (navigator.share) {
    button.classList.remove("hidden");
    button.onclick = function () {
      navigator.share({
        url: document.location.href,
        title: document.title,
      });
    };
  } else {
    summary.classList.remove("hidden");

    copy.onclick = function () {
      navigator.clipboard.writeText(input.value).then(function () {
        message.classList.remove("hidden");
        close.classList.remove("hidden");

        message.textContent = btyStrings.general.share_success;
      });
    };

    // Click any to close.
    document.addEventListener("click", function (e) {
      if (e.target.closest(".product-share")) {
        return;
      }

      closeAction();
    });

    // Use ESC key.
    document.addEventListener("keyup", function (e) {
      if (27 !== e.keyCode) {
        return;
      }

      closeAction();
    });

    // Close button.
    close.onclick = closeAction;
  }
}

// Sale notification.
function btySalesNotification(doc = document) {
  let selector = doc.querySelector(".sales-notification");
  if (!selector) {
    return;
  }

  let inner = selector.querySelector(".sn-inner"),
    options = selector.querySelector("[data-options]"),
    items = selector.querySelector("[data-items]");
  if (!inner || !options || !items) {
    return;
  }

  let parseOptions = btyJsonParse(options.content.textContent),
    parseItems = new DOMParser().parseFromString(items.innerHTML, "text/html");

  // Remove html template.
  options.remove();
  items.remove();

  let length = parseItems.querySelectorAll(".sn-item");
  if (!length.length) {
    return;
  }

  // Get random item in array.
  const randomItem = function (arr = []) {
    return arr[Math.floor(Math.random() * arr.length)];
  };

  // Display function.
  const displayFn = function () {
    let item = randomItem(length),
      time = item.querySelector(".sn-time"),
      customer = item.querySelector(".sn-customer");

    // Append time text.
    if (time) {
      time.innerText = randomItem(parseOptions.virtual_times);
    }

    // Append customer text.
    if (customer) {
      customer.innerText =
        randomItem(parseOptions.virtual_customers) + parseOptions.purchased;
    }

    inner.innerHTML = item.outerHTML;

    let current = inner.querySelector(".sn-item");
    if (!current) {
      return;
    }

    // Set animation.
    setTimeout(function () {
      current.classList.add("active");
    }, 50);

    // Start loading bar when animation end.
    setTimeout(function () {
      current.insertAdjacentHTML(
        "beforeend",
        '<span class="underline-animated' +
          (parseOptions.loading_bar ? "" : " visibility-hidden") +
          '"></span>',
      );

      // Remove notification after animation end.
      let animation = current.querySelector(".underline-animated");
      if (animation) {
        animation.addEventListener("animationend", function () {
          current.classList.add("down");
        });
      }
    }, 300);

    // Remove notification by click to Close button.
    let closeBtn = current.querySelector(".sn-close");
    if (closeBtn) {
      closeBtn.onclick = function () {
        current.classList.add("down");
      };
    }
  };

  let init,
    timeTotal = parseOptions.time_total * 1000;
  setTimeout(function () {
    displayFn();

    init = setInterval(displayFn, timeTotal);
  }, parseOptions.time_init * 1000);
}

// Newsletter popup.
function btyNewsletterPopup(doc = document) {
  let form = doc.querySelector(".newsletter-popup-form");
  if (!form) {
    return;
  }

  let delay = form.getAttribute("data-delay");

  setTimeout(function () {
    // Set cookies.
    // Always show popup when Display mode set to Test mode.
    if (Shopify.designMode && "" === form.getAttribute("data-mode")) {
      form.parentNode.classList.add("closed");
    } else {
      if ("test" === form.getAttribute("data-mode")) {
        form.parentNode.classList.remove("closed");
      } else {
        if (form.classList.contains("first-visit")) {
          const getCookie = new URLSearchParams(
            document.cookie.replaceAll("&", "%26").replaceAll("; ", "&"),
          );
          if (!getCookie.get("newsletter-popup-cookie")) {
            form.parentNode.classList.remove("closed");
          }

          function setCookie(cname, cvalue, exdays) {
            let d = new Date();

            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);

            let expires = "expires=" + d.toUTCString();

            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
          }

          setCookie("newsletter-popup-cookie", 1, 30);
        } else {
          form.parentNode.classList.remove("closed");
        }
      }
    }

    // Click to popup overlay.
    form.addEventListener("click", function (e) {
      if (e.target != form) {
        return;
      }

      form.parentNode.classList.add("closed");
    });

    // Use ESC key.
    document.addEventListener("keyup", function (e) {
      if (27 !== e.keyCode) {
        return;
      }

      form.parentNode.classList.add("closed");
    });

    // Use close button.
    let button = form.querySelector(".close-button");
    if (button) {
      button.onclick = function () {
        form.parentNode.classList.add("closed");
      };
    }
  }, Number(delay));
}

// Cookies bar.
function btyCookiesBar(doc = document) {
  let box = doc.querySelector(".cookies-bar"),
    button = doc.querySelector(".button-cookies");

  if (
    !box ||
    !button ||
    (Shopify.designMode && "" === box.getAttribute("data-mode"))
  ) {
    return;
  }

  const getCookie = new URLSearchParams(
    document.cookie.replaceAll("&", "%26").replaceAll("; ", "&"),
  );
  if (!getCookie.get("acceptCookies")) {
    box.classList.add("show");
  }

  function setCookie(cname, cvalue, exdays) {
    let d = new Date();

    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);

    let expires = "expires=" + d.toUTCString();

    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  button.onclick = function () {
    if ("" === box.getAttribute("data-mode")) {
      setCookie("acceptCookies", 1, 30);
    } else {
      document.cookie =
        "acceptCookies=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    box.classList.remove("show");
  };
}

// Hover media video.
function btyHoverMediaVideo(doc = document) {
  let selectors = doc.querySelectorAll(".hover-media-video");
  if (!selectors.length) {
    return;
  }

  selectors.forEach(function (el) {
    el.addEventListener("mousemove", function () {
      btyMediaAction(el, "play");
    });

    el.addEventListener("mouseleave", function () {
      btyMediaAction(el, "pause");
    });
  });
}

// Animation for image load.
function btyAnimationImageLoad(doc = document, delay = 0) {
  let images = doc.querySelectorAll(".lazy-image img");
  if (!images.length) {
    return;
  }

  const imgLazyObserver = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (entry.target.dataset.src) {
            entry.target.src = entry.target.dataset.src;
          }

          if (entry.target.dataset.srcSet) {
            entry.target.srcSet = entry.target.dataset.srcSet;
          } else if (entry.target.dataset.srcset) {
            entry.target.setAttribute("srcset", entry.target.dataset.srcset);
          }

          entry.target.removeAttribute("data-src");
          entry.target.removeAttribute("data-srcset");

          entry.target.addEventListener("load", function () {
            entry.target.parentNode.classList.add("lazy-loaded");
          });

          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: "-20px 0px -20px 0px",
    },
  );

  images.forEach(function (img) {
    if (img.parentNode.classList.contains("lazy-loaded")) {
      return;
    }

    imgLazyObserver.observe(img);
  });
}

// Collection sticky.
function btyCollectionSticky(doc = document) {
  let items = doc.querySelectorAll(".collection-sticky");
  if (!items.length) {
    return;
  }

  const stickCollection = function () {
    items.forEach(function (el) {
      let box = el.querySelector(".heading-box"),
        subHeading = box
          ? box.querySelector(".sub-heading .dynamic-label")
          : false,
        heading = box ? box.querySelector(".heading .dynamic-label") : false,
        button = box
          ? box.querySelector(".collection-list-button .dynamic-label")
          : false,
        cards = el.querySelectorAll(".card-item");
      if (!cards.length) {
        return;
      }

      for (let i = 0, j = cards.length; i < j; i++) {
        let rect = cards[i].getBoundingClientRect(),
          index = i + 1,
          current = el.querySelector(".card-item:nth-child(" + index + ")");

        if (!current) {
          return;
        }

        let title = current.getAttribute("data-title"),
          dataSubHeading = current.getAttribute("data-subheading"),
          dataHeading = current.getAttribute("data-heading"),
          href = current.getAttribute("data-href");
        if (rect.top <= 1 && rect.top >= rect.height * -1) {
          if (button && button.innerText != title) {
            if (href.trim()) {
              button.parentNode.href = href;
            }

            if (title.trim()) {
              button.innerText = title;
            }

            button.parentNode.classList.add("bounce-it");
            setTimeout(function () {
              button.parentNode.classList.remove("bounce-it");
            }, 1000);
          }

          if (dataSubHeading.trim() && subHeading) {
            subHeading.innerText = dataSubHeading;
          }

          if (dataHeading.trim() && heading) {
            heading.innerText = dataHeading;
          }
        }
      }
    });
  };

  stickCollection();

  // Trigger.
  window.addEventListener("scroll", function () {
    stickCollection();
  });
}

// Load media.
function btyLoadMedia(selector = undefined, action = "play") {
  if (!selector) {
    return;
  }

  let wrapper = selector.querySelector(".media-preview-wrap"),
    playBtn = selector.querySelector(".view-media");

  if (!playBtn) {
    return;
  }

  // Return if media loaded.
  if (wrapper.classList.contains("media-loaded")) {
    btyMediaAction(wrapper, action);

    return;
  }

  // Play current video.
  btyMediaAction(wrapper, action);

  let template = selector.querySelector("template"),
    mediaDiv = wrapper.querySelector(".media-content");

  if (!mediaDiv) {
    wrapper.classList.add("media-loaded");

    if (template) {
      wrapper.insertAdjacentHTML(
        "beforeend",
        '<div class="media-content">' + template.innerHTML + "</div>",
      );
    }
  }

  // Remove model after loaded, inside <template> tag.
  if (template) {
    template.remove();
  }
}

// Load media on desktop.
function btyMediaDesktop(doc = document) {
  let selectors = doc.querySelectorAll(".main-item");
  if (!selectors.length) {
    return;
  }

  selectors.forEach(function (el) {
    if (el.hasAttribute("data-image")) {
      return;
    }

    el.addEventListener("click", function (event) {
      // Prevent event bubbling.
      event.stopPropagation();

      // Pause all other media items.
      selectors.forEach(function (item) {
        if (item !== el && item.getAttribute("data-playing") === "true") {
          btyLoadMedia(item, "pause");
          item.setAttribute("data-playing", "false");
        }
      });

      // Toggle play/pause state for clicked item.
      const isPlaying = el.getAttribute("data-playing") === "true";
      btyLoadMedia(el, isPlaying ? "pause" : "play");
      el.setAttribute("data-playing", isPlaying ? "false" : "true");
    });
  });
}

// Scroll to top.
function btyScrollToTop() {
  let myButton = document.getElementById("btnScrollToTop");

  if (!myButton) {
    return;
  }

  window.onscroll = function () {
    // Display after 400px height.
    if (window.pageYOffset >= 400) {
      myButton.classList.add("is-visible");
    } else {
      myButton.classList.remove("is-visible");
    }
  };

  // Onclick function.
  myButton.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  });
}

// Popup focus.
function btyTrapFocus(container, firstFocusableElement) {
  const focusableElements = container.querySelectorAll(
    'a[href], button:not([disabled]), input, textarea, select, details, [tabindex]:not([tabindex="-1"])',
  );

  const firstElement = firstFocusableElement || focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  function handleKeyDown(e) {
    if (e.key === "Tab") {
      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          e.preventDefault();
          lastElement.focus();
        }
      } else {
        if (document.activeElement === lastElement) {
          e.preventDefault();
          firstElement.focus();
        }
      }
    }
  }

  container.addEventListener("keydown", handleKeyDown);
}
// Animation for accordion.
class btyAccordion {
  constructor(el, toggle = "summary", view = ".details-content") {
    const accordion = this;

    accordion.el = el;
    accordion.summary = el.querySelector(toggle);
    accordion.content = el.querySelector(view);

    accordion.animation = null;
    accordion.isClosing = false;
    accordion.isExpanding = false;

    if (!accordion.content) {
      return;
    }

    accordion.summary.addEventListener("click", function (e) {
      accordion.onClick(e);
    });
  }

  onClick(e) {
    e.preventDefault();
    const accordion = this;

    accordion.el.style.overflow = "hidden";

    let aria = accordion.summary.getAttribute("aria-expanded");

    if (accordion.isClosing || !accordion.el.open) {
      accordion.open();

      if (aria) {
        accordion.summary.setAttribute("aria-expanded", "true");
      }
    } else if (accordion.isExpanding || accordion.el.open) {
      accordion.shrink();

      if (aria) {
        accordion.summary.setAttribute("aria-expanded", "false");
      }
    }
  }

  shrink() {
    const accordion = this;

    accordion.isClosing = true;

    let startHeight = accordion.el.offsetHeight + "px",
      endHeight = accordion.summary.offsetHeight + "px";

    if (accordion.animation) {
      accordion.animation.cancel();
    }

    accordion.animation = accordion.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 200,
        easing: "ease-out",
      },
    );

    accordion.animation.onfinish = function () {
      accordion.onAnimationFinish(false);
    };

    accordion.animation.oncancel = function () {
      accordion.isClosing = false;
    };
  }

  open() {
    const accordion = this;

    accordion.el.style.height = accordion.el.offsetHeight + "px";
    accordion.el.open = true;

    window.requestAnimationFrame(function () {
      accordion.expand();
    });
  }

  expand() {
    const accordion = this;

    accordion.isExpanding = true;

    let startHeight = accordion.el.offsetHeight + "px",
      endHeight =
        accordion.summary.offsetHeight + accordion.content.offsetHeight + "px";

    if (accordion.animation) {
      accordion.animation.cancel();
    }

    accordion.animation = accordion.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 200,
        easing: "ease-out",
      },
    );

    accordion.animation.onfinish = function () {
      accordion.onAnimationFinish(true);
    };

    accordion.animation.oncancel = function () {
      accordion.isExpanding = false;
    };
  }

  onAnimationFinish(open) {
    const accordion = this;

    accordion.el.open = open;
    accordion.animation = null;
    accordion.isClosing = false;
    accordion.isExpanding = false;

    accordion.el.removeAttribute("style");
  }
}

function btyAccordionHandle(doc = document) {
  let details = doc.querySelectorAll("details");
  if (!details.length) {
    return;
  }

  details.forEach(function (el) {
    // No apply effect for motion reduce node.
    if (el.hasAttribute("data-motion-reduce")) {
      return;
    }

    new btyAccordion(el);
  });
}

// Accordion hover.
function btyAccordionHover(doc = document) {
  let menus = doc.querySelectorAll(".menu-map.faq-accordion");

  if (!menus.length) {
    return;
  }

  menus.forEach(function (el) {
    let section = el.closest(".shopify-section"),
      id = el.getAttribute("data-id"),
      container = section
        ? section.querySelectorAll('.content-map[data-id="' + id + '"]')
        : [];

    el.addEventListener("mouseenter", function () {
      if (
        window.matchMedia("(max-width: 991px)").matches ||
        window.matchMedia("(hover: none)").matches
      ) {
        return;
      }

      if (container.length) {
        container.forEach(function (con) {
          let sibs = btySiblings(con);
          if (sibs.length) {
            sibs.forEach(function (sib) {
              sib.classList.remove("active");
            });
          }

          con.classList.add("active");
        });
      }
    });
  });
}

// Scroll in animation logic.
function btyIntersection(elements, observer) {
  const offscreen = "scroll-trigger-offscreen";

  elements.forEach((el, index) => {
    if (el.isIntersecting) {
      const target = el.target;

      if (target.classList.contains(offscreen)) {
        target.classList.remove(offscreen);

        target.setAttribute("style", "--animation-order: " + index + ";");
      }

      observer.unobserve(target);
    } else {
      el.target.classList.add(offscreen);
    }
  });
}

// Scroll trigger.
function btyScrollAnimationTrigger(doc = document, designMode = false) {
  const selectors = Array.from(doc.getElementsByClassName("scroll-trigger"));
  if (!selectors.length) {
    return;
  }

  if (designMode) {
    selectors.forEach((el) => {
      el.classList.add("scroll-trigger-design-mode");
    });

    return;
  }

  const observer = new IntersectionObserver(btyIntersection, {
    rootMargin: "0px 0px -30px 0px",
    threshold: 0,
  });

  selectors.forEach((el) => observer.observe(el));
}

function btyTogglePassword(doc = document) {
  let selectors = doc.querySelectorAll(".customer .field-password");

  if (!selectors.length) {
    return;
  }

  selectors.forEach(function (el) {
    let togglePassword = el.querySelector(".field-icon"),
      passwordInput = el.querySelector("input");

    togglePassword.onclick = function () {
      let type = passwordInput.getAttribute("type");

      if (type === "password") {
        passwordInput.setAttribute("type", "text");

        togglePassword.querySelector(".pass-show").classList.add("hidden");
        togglePassword.querySelector(".pass-hide").classList.remove("hidden");
      } else {
        passwordInput.setAttribute("type", "password");

        togglePassword.querySelector(".pass-show").classList.remove("hidden");
        togglePassword.querySelector(".pass-hide").classList.add("hidden");
      }
    };
  });
}
function btyHeaderSticky() {
  // TODO: remove whole function?
  return;

  let header = document.querySelector(".header.is-sticky");
  if (!header) {
    return;
  }

  let doc = document.documentElement,
    top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0),
    height = header.offsetHeight,
    sitepanel = header.querySelector(".site-panel"),
    sitecart = doc.querySelector(".side-cart");

  const isMobile = window.matchMedia("(max-width: 991px)").matches;

  if (top > height) {
    header.classList.add("solid-sticky");

    if (isMobile) {
      if (sitepanel) {
        sitepanel.style.top = `${height - 1}px`;
      }

      if (sitecart) {
        sitecart.style.top = `${height - 1}px`;
      }
    } else {
      if (sitepanel) {
        sitepanel.removeAttribute("style");
      }

      if (sitecart) {
        sitecart.removeAttribute("style");
      }
    }
  } else {
    header.classList.remove("solid-sticky");

    if (sitepanel) {
      sitepanel.removeAttribute("style");
    }

    if (sitecart) {
      sitecart.removeAttribute("style");
    }
  }
}
function btyToggleNavMenu(doc = document) {
  let selectors = doc.querySelectorAll(
    ".header-navigation .menu-item .menu-toggle",
  );

  if (!selectors.length) {
    return;
  }

  selectors.forEach(function (el) {
    let menuItem = el.parentNode,
      header = el.closest(".header");

    if (!menuItem || !header) {
      return;
    }

    el.onclick = function () {
      menuItem.classList.toggle("open");

      if (
        doc.querySelectorAll(".header-navigation .menu-item.open").length > 0
      ) {
        header.classList.add("menu-open");
      } else {
        header.classList.remove("menu-open");
      }
    };

    document.addEventListener("click", (event) => {
      if (!menuItem.contains(event.target)) {
        menuItem.classList.remove("open");

        if (
          doc.querySelectorAll(".header-navigation .menu-item.open").length > 0
        ) {
          header.classList.add("menu-open");
        } else {
          header.classList.remove("menu-open");
        }
      }
    });
  });
}
/**
 * Predictive Search
 *
 * @package Dev
 */

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('.quick-search-form input[type="search"]');
    this.predictiveSearchResults = this.querySelector(
      ".quick-search-form #predictive-search",
    );
    this.modalSearch = this.querySelector(".quick-search-form .search-modal");
    this.searchButton = this.querySelector(".quick-search-form .search-button");
    this.resetButton = this.querySelector(".quick-search-form .reset-button");

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );

    this.input.addEventListener("focus", (event) => {
      this.onFocus(event);
    });

    this.addEventListener("focusout", (event) => {
      this.onFocusOut(event);
    });

    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));

      this.input.addEventListener(
        "input",
        this.debounce((event) => {
          this.toggleResetButton();
        }, 300).bind(this),
      );
    }

    window.addEventListener("resize", () => {
      this.updateResultsMaxHeight();
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onFocus() {
    this.setAttribute("open", true);

    // Add padding in search bar section.
    const wrapper = this.closest(".search-bar-section .section-wrapper > div");
    if (wrapper) {
      wrapper.style.paddingBottom =
        this.predictiveSearchResults.offsetHeight + 16 + "px";
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.removeAttribute("open");

        // Remove padding in search bar section.
        const wrapper = this.closest(
          ".search-bar-section .section-wrapper > div",
        );
        if (wrapper) {
          wrapper.removeAttribute("style");
        }
      }
    });
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(
      `/search/suggest?q=${searchTerm}&resources[type]=query,product,collection,page,article&section_id=predictive-search`,
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;

        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight -
      document
        .querySelector(".quick-search .form-wrapper")
        ?.getBoundingClientRect().bottom -
      32;
    return this.resultsMaxHeight;
  }

  updateResultsMaxHeight() {
    let maxHeight = this.getResultsMaxHeight();
    this.predictiveSearchResults.style.maxHeight = `${maxHeight}px`;

    // Update padding in search bar section.
    const wrapper = this.closest(".search-bar-section .section-wrapper > div");
    if (wrapper) {
      wrapper.style.paddingBottom =
        this.predictiveSearchResults.offsetHeight + 16 + "px";
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && resetIsHidden) {
      this.searchButton.classList.add("hidden");
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.searchButton.classList.remove("hidden");
      this.resetButton.classList.add("hidden");
    }
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load.
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown.
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
      this.close();
    }
  }

  open() {
    this.setAttribute("results", true);
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.updateResultsMaxHeight();

    // Add padding in search bar section.
    const wrapper = this.closest(".search-bar-section .section-wrapper > div");
    if (wrapper) {
      wrapper.style.paddingBottom =
        this.predictiveSearchResults.offsetHeight + 16 + "px";
    }
  }

  close() {
    this.removeAttribute("results");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");

    // Remove padding in search bar section.
    const wrapper = this.closest(".search-bar-section .section-wrapper > div");
    if (wrapper) {
      wrapper.removeAttribute("style");
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define("predictive-search", PredictiveSearch);

class ScrollingHandler extends HTMLElement {
  constructor() {
    super();

    this.width = 0;
    this.scrolling = this.querySelector(".scrolling-inner");

    window.addEventListener("DOMContentLoaded", this.handler.bind(this));
    window.addEventListener("resize", this.handler.bind(this));

    document.addEventListener("shopify:section:load", this.handler.bind(this));
    document.addEventListener(
      "shopify:section:select",
      this.handler.bind(this),
    );
    document.addEventListener("shopify:block:select", this.handler.bind(this));
    document.addEventListener("product-card-updated", this.handler.bind(this));
  }

  handler() {
    if (this.width == window.innerWidth) {
      return;
    }

    this.width = window.innerWidth;
    this.scrolling.classList.remove("scrolling-animation");
    let boxes = this.querySelectorAll(".scrolling-dup");
    if (boxes.length) {
      boxes.forEach((e) => e.remove());
    }

    let localWidth = this.closest(".scrolling-wrapper").offsetWidth,
      length = localWidth / this.scrolling.offsetWidth,
      dup = false;

    length = length == Infinity ? 5 : length;

    for (let i = 0; i < length; i++) {
      dup = this.scrolling.cloneNode(true);
      dup.classList.add("scrolling-dup", "scrolling-animation");
      this.prepend(dup);
    }

    this.scrolling.classList.add("scrolling-animation");
  }
}
customElements.define("scrolling-item", ScrollingHandler);
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.quick-search-form input[type="search"]');
    this.searchButton = this.querySelector(".quick-search-form .search-button");
    this.resetButton = this.querySelector(".quick-search-form .reset-button");

    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener(
        "input",
        this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this),
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && resetIsHidden) {
      this.searchButton.classList.add("hidden");
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.searchButton.classList.remove("hidden");
      this.resetButton.classList.add("hidden");
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("search-form", SearchForm);

// Parallax image.
function btyParallaxImage(doc = document) {
  let layers = doc.querySelectorAll(".parallax-layer");
  if (!layers.length) {
    return;
  }

  document.addEventListener("mousemove", function (e) {
    const x = e.clientX / window.innerWidth;
    const y = e.clientY / window.innerHeight;

    layers.forEach((layer, index) => {
      const speed = index * 0.5 + 0.5;
      const xOffset = (x - 0.5) * speed * 100;
      const yOffset = (y - 0.5) * speed * 100;

      layer.style.transform = `translate(${xOffset}px, ${yOffset}px)`;
    });
  });
}
// Text hover image.
function btyTextHoverImage(doc = document) {
  let selectors = doc.querySelectorAll(
    ".collection-list-hover-section .item .hover-item-text",
  );
  if (!selectors.length) {
    return;
  }

  selectors.forEach(function (el) {
    let image = el.parentNode.parentNode.querySelector(".hover-item-image");
    if (!image) {
      return;
    }

    el.onmousemove = function (e) {
      image.style.transform =
        "translate3d(" + e.layerX + "px, " + e.layerY + "px, 0px)";

      // Set opacity for all text elements.
      selectors.forEach(function (otherEl) {
        if (otherEl !== el) {
          otherEl.style.opacity = "0.1"; // Reduce opacity of non-hovered items.
        } else {
          otherEl.style.opacity = "1"; // Keep the hovered element fully visible.
        }
      });
    };

    // Reset opacity when mouse leaves the element.
    el.onmouseleave = function () {
      selectors.forEach(function (otherEl) {
        otherEl.style.opacity = "1"; // Restore opacity for all elements when mouse leaves.
      });
    };
  });
}

// Text hover image.
function btyTextHoverShowImage(doc = document) {
  const listItems = doc.querySelectorAll(
    ".collection-list-hover-section .list-item",
  );

  if (!listItems.length) {
    return;
  }

  listItems.forEach((item) => {
    item.addEventListener("click", () => {
      const isActive = item.classList.contains("active");

      // Close all other items
      listItems.forEach((i) => i.classList.remove("active"));

      // Toggle the clicked item
      if (!isActive) {
        item.classList.add("active");
      }
    });

    item.onmousemove = function (e) {
      // Set opacity for all text elements.
      listItems.forEach(function (otherItem) {
        if (otherItem !== item) {
          otherItem.style.opacity = "0.1"; // Reduce opacity of non-hovered items.
        } else {
          otherItem.style.opacity = "1"; // Keep the hovered element fully visible.
        }
      });
    };

    // Reset opacity when mouse leaves the element.
    item.onmouseleave = function () {
      listItems.forEach(function (otherItem) {
        otherItem.style.opacity = "1"; // Restore opacity for all elements when mouse leaves.
      });
    };
  });
}
function btyFeaturedBlogListHover(doc = document) {
  let selectors = doc.querySelectorAll(
    ".featured-blog-section .featured-blog-list .article-card",
  );
  if (!selectors.length) {
    return;
  }

  selectors.forEach(function (el) {
    el.addEventListener("mouseover", function () {
      let data_id = el.getAttribute("data-id"),
        list_media = el
          .closest(".featured-blog")
          ?.querySelector(".featured-blog-image");

      if (!data_id || !list_media) {
        return;
      }

      // Hide all media elements that do not have a data-id matching the current card's data_id.
      let allMedia = list_media.querySelectorAll(".article-media");
      allMedia.forEach(function (media) {
        media.classList.add("hidden");
      });

      // Show the media element with a data-id matching the current card's data_id.
      let targetMedia = list_media.querySelector(
        '.article-media[data-media-id="' + data_id + '"]',
      );
      if (targetMedia) {
        targetMedia.classList.remove("hidden");
      }
    });
  });
}
// Featured product list hover.
function btyFeaturedProuctListHover(doc = document) {
  let selectors = doc.querySelectorAll(
    ".featured-product-section .product-card",
  );
  if (!selectors.length) {
    return;
  }

  selectors.forEach(function (el) {
    el.addEventListener("mouseover", function () {
      let data_id = el.getAttribute("data-id"),
        list_media = el
          .closest(".featured-product")
          ?.querySelector(".featured-product-image");

      if (!data_id || !list_media) {
        return;
      }

      let allMedia = list_media.querySelectorAll(".product-media");
      let targetMedia = list_media.querySelector(
        '.product-media[data-media-id="' + data_id + '"]',
      );

      // Hide all media.
      allMedia.forEach(function (media) {
        media.classList.add("hidden");
      });

      // Show media with the same data_id.
      if (targetMedia) {
        targetMedia.classList.remove("hidden");
      }
    });

    let variants = el.querySelector("[data-product-variants]"),
      field = el.querySelectorAll(".field-value"),
      index = el.getAttribute("data-index"),
      form = el
        .closest(".featured-product-section")
        .querySelector('[data-type="add-to-cart-form"]'),
      icon = el.querySelector(".icon"),
      iconPlus = el.querySelector(".icon .icon-plus"),
      iconCheck = el.querySelector(".icon .icon-check");

    if (variants) {
      variants = btyJsonParse(variants.textContent);

      let price = el.querySelector(".product-price"),
        variant_pick = {};

      if (field.length) {
        field.forEach(function (fieldEl) {
          variant_pick[fieldEl.name] = fieldEl.value;

          let selected = btySelectedVariant(
              variant_pick,
              variants,
              window.btyMainSlider,
            ),
            productMessage = el.querySelector(".message");

          if (selected) {
            if (!selected.available) {
              if (el.classList.contains("active")) {
                el.classList.remove("active");

                if (iconPlus && iconCheck) {
                  iconPlus.classList.remove("hidden");
                  iconCheck.classList.add("hidden");
                }
              }

              if (icon) {
                icon.disabled = true;
              }

              if (productMessage) {
                productMessage.innerHTML = btyStrings.product.variant_sold_out;
              }
            } else {
              if (icon) {
                icon.disabled = false;
              }

              if (productMessage) {
                productMessage.innerHTML = "";
              }
            }
          } else {
            if (el.classList.contains("active")) {
              el.classList.remove("active");

              if (iconPlus && iconCheck) {
                iconPlus.classList.remove("hidden");
                iconCheck.classList.add("hidden");
              }
            }

            if (icon) {
              icon.disabled = true;
            }

            if (productMessage) {
              productMessage.innerHTML = btyStrings.product.variant_unavailable;
            }
          }

          fieldEl.onchange = function () {
            variant_pick[fieldEl.name] = fieldEl.value;

            let selected = btySelectedVariant(
              variant_pick,
              variants,
              window.btyMainSlider,
            );
            if (selected) {
              // Check variant sold out.
              let productMessage = el.querySelector(".message");

              if (!selected.available) {
                if (el.classList.contains("active")) {
                  el.classList.remove("active");

                  if (iconPlus && iconCheck) {
                    iconPlus.classList.remove("hidden");
                    iconCheck.classList.add("hidden");
                  }
                }

                if (icon) {
                  icon.disabled = true;
                }

                if (productMessage) {
                  productMessage.innerHTML =
                    btyStrings.product.variant_sold_out;
                }
              } else {
                if (icon) {
                  icon.disabled = false;
                }

                if (productMessage) {
                  productMessage.innerHTML = "";
                }
              }

              // Update price.
              if (price) {
                price.innerHTML = btyPriceHtml(
                  selected.price,
                  selected.compare_at_price,
                  selected.unit_price,
                  selected.unit_price_measurement,
                );
              }

              // Update product variant ID in total.
              if (form && index) {
                let idInput = form.querySelector(
                    '[name="items[' + index + '][id]"]',
                  ),
                  quantityInput = form.querySelector(
                    '[name="items[' + index + '][quantity]"]',
                  ),
                  priceInput = form.querySelector(
                    '[name="items[' + index + '][price]"]',
                  );

                if (idInput) {
                  idInput.value = selected.id;
                }

                if (priceInput) {
                  priceInput.value = selected.price;
                }

                if (!selected.available) {
                  if (idInput) {
                    idInput.disabled = true;
                  }

                  if (quantityInput) {
                    quantityInput.disabled = true;
                  }

                  if (priceInput) {
                    priceInput.disabled = true;
                  }
                }
              }

              // Calculate the total price and update the totalPriceSpan.
              let totalPrice = 0;

              let button = form.querySelector(".add-to-cart-button"),
                activeProducts = el.parentNode.querySelectorAll(
                  ".product-card[data-id].active",
                );

              activeProducts.forEach(function (activeProduct) {
                let activeProductIndex =
                    activeProduct.getAttribute("data-index"),
                  activeProductPrice = form.querySelector(
                    '[name="items[' + activeProductIndex + '][price]"]',
                  )?.value,
                  activeProductQuantity = form.querySelector(
                    '[name="items[' + activeProductIndex + '][quantity]"]',
                  )?.value;

                // Ensure valid price and quantity.
                if (activeProductPrice && activeProductQuantity) {
                  totalPrice +=
                    parseFloat(activeProductPrice) *
                    parseInt(activeProductQuantity);
                }
              });

              // Update the total price in the span.
              let totalPriceSpan = form.querySelector(".total-price");
              if (totalPriceSpan) {
                if (totalPrice === 0) {
                  totalPriceSpan.textContent = "";
                } else {
                  totalPriceSpan.textContent =
                    btyFormatPrice(totalPrice) + " - ";
                }
              }

              if (button && activeProducts.length > 0) {
                button.disabled = false;
              } else {
                button.disabled = true;
              }
            } else {
              let productMessage = el.querySelector(".message");

              if (el.classList.contains("active")) {
                el.classList.remove("active");

                if (iconPlus && iconCheck) {
                  iconPlus.classList.remove("hidden");
                  iconCheck.classList.add("hidden");
                }
              }

              if (icon) {
                icon.disabled = true;
              }

              if (productMessage) {
                productMessage.innerHTML =
                  btyStrings.product.variant_unavailable;
              }

              // Clear price.
              if (price) {
                price.innerHTML = "";
              }

              // Clear and disable inputs.
              if (form && index) {
                let idInput = form.querySelector(
                    '[name="items[' + index + '][id]"]',
                  ),
                  quantityInput = form.querySelector(
                    '[name="items[' + index + '][quantity]"]',
                  ),
                  priceInput = form.querySelector(
                    '[name="items[' + index + '][price]"]',
                  );

                if (idInput) {
                  idInput.value = "";
                  idInput.disabled = true;
                }

                if (priceInput) {
                  priceInput.value = "";
                  priceInput.disabled = true;
                }

                if (quantityInput) {
                  quantityInput.value = "1";
                  quantityInput.disabled = true;
                }
              }

              // Calculate the total price and update the totalPriceSpan.
              let totalPrice = 0;

              let button = form.querySelector(".add-to-cart-button"),
                activeProducts = el.parentNode.querySelectorAll(
                  ".product-card[data-id].active",
                );

              activeProducts.forEach(function (activeProduct) {
                let activeProductIndex =
                    activeProduct.getAttribute("data-index"),
                  activeProductPrice = form.querySelector(
                    '[name="items[' + activeProductIndex + '][price]"]',
                  )?.value,
                  activeProductQuantity = form.querySelector(
                    '[name="items[' + activeProductIndex + '][quantity]"]',
                  )?.value;

                // Ensure valid price and quantity.
                if (activeProductPrice && activeProductQuantity) {
                  totalPrice +=
                    parseFloat(activeProductPrice) *
                    parseInt(activeProductQuantity);
                }
              });

              // Update the total price in the span.
              let totalPriceSpan = form.querySelector(".total-price");
              if (totalPriceSpan) {
                if (totalPrice === 0) {
                  totalPriceSpan.textContent = "";
                } else {
                  totalPriceSpan.textContent =
                    btyFormatPrice(totalPrice) + " - ";
                }
              }

              if (button && activeProducts.length > 0) {
                button.disabled = false;
              } else {
                button.disabled = true;
              }
            }
          };
        });
      }
    }

    if (icon) {
      icon.addEventListener("click", function () {
        if (el.classList.contains("active")) {
          el.classList.remove("active");

          if (iconPlus && iconCheck) {
            iconPlus.classList.remove("hidden");
            iconCheck.classList.add("hidden");
          }
        } else {
          el.classList.add("active");

          if (iconPlus && iconCheck) {
            iconPlus.classList.add("hidden");
            iconCheck.classList.remove("hidden");
          }
        }

        if (form) {
          if (index) {
            let idInput = form.querySelector(
                '[name="items[' + index + '][id]"]',
              ),
              quantityInput = form.querySelector(
                '[name="items[' + index + '][quantity]"]',
              ),
              priceInput = form.querySelector(
                '[name="items[' + index + '][price]"]',
              ),
              totalPrice = 0;

            if (idInput) {
              idInput.toggleAttribute("disabled");
            }

            if (quantityInput) {
              quantityInput.toggleAttribute("disabled");
            }

            if (priceInput) {
              priceInput.toggleAttribute("disabled");
            }

            let button = form.querySelector(".add-to-cart-button"),
              activeProducts = el.parentNode.querySelectorAll(
                ".product-card[data-id].active",
              );

            activeProducts.forEach(function (activeProduct) {
              let activeProductIndex = activeProduct.getAttribute("data-index"),
                activeProductPrice = form.querySelector(
                  '[name="items[' + activeProductIndex + '][price]"]',
                )?.value,
                activeProductQuantity = form.querySelector(
                  '[name="items[' + activeProductIndex + '][quantity]"]',
                )?.value;

              // Ensure valid price and quantity.
              if (activeProductPrice && activeProductQuantity) {
                totalPrice +=
                  parseFloat(activeProductPrice) *
                  parseInt(activeProductQuantity);
              }
            });

            // Update the total price in the span.
            let totalPriceSpan = form.querySelector(".total-price");
            if (totalPriceSpan) {
              if (totalPrice === 0) {
                totalPriceSpan.textContent = "";
              } else {
                totalPriceSpan.textContent = btyFormatPrice(totalPrice) + " - ";
              }
            }

            if (button && activeProducts.length > 0) {
              button.disabled = false;
            } else {
              button.disabled = true;
            }
          }
        }
      });
    }
  });
}
// Marquee.
class MarqueeHandler extends HTMLElement {
  constructor() {
    super();

    this.width = 0;
    this.marquee = this.querySelector(".marquee-wrapper");
    setTimeout(this.resizeHandler.bind(this), 100);
    window.addEventListener("resize", this.resizeHandler.bind(this), false);
    this.querySelectorAll("[loading]").forEach((item) => {
      item.removeAttribute("loading");
    });

    const isInEditor =
      this.marquee && this.marquee.getAttribute("data-design-mode") === "true";

    if (!isInEditor) {
      this.marquee.classList.remove("marquee-animation");
    }
  }

  resizeHandler() {
    if (this.width == window.innerWidth) {
      return;
    }

    this.width = window.innerWidth;
    this.marquee.classList.remove("marquee-animation");
    let boxes = this.querySelectorAll(".marquee-dup");

    if (boxes.length) {
      boxes.forEach((e) => e.remove());
    }

    let local_width = this.closest(".marquee-section").offsetWidth,
      length = local_width / this.marquee.offsetWidth,
      dup = false;

    length = length == Infinity ? 5 : length;

    for (let i = 0; i < length; i++) {
      dup = this.marquee.cloneNode(true);
      dup.classList.add("marquee-dup", "marquee-animation");
      this.prepend(dup);
    }

    this.marquee.classList.add("marquee-animation");
  }
}
customElements.define("marquee-section", MarqueeHandler);
function btyTestimonialProduct(doc = document) {
  let selectors = doc.querySelectorAll(".testimonial-product");
  if (!selectors.length) {
    return;
  }

  selectors.forEach(function (el) {
    let imageCarouselOption,
      imageCarousel,
      textCarouselOption,
      textCarousel,
      imageEl = el.querySelector(".image-content .swiper"),
      textEl = el.querySelector(".text-content .swiper"),
      mobile =
        window.matchMedia("(max-width: 991px)").matches ||
        window.matchMedia("(hover: none)").matches,
      value = mobile ? 15 : 10;

    imageCarouselOption = {
      speed: 300,
      slidesPerView: 1,
      loop: true,
      loopedSlides: 3,
      allowTouchMove: false,
      creativeEffect: {
        limitProgress: 2,
        prev: {
          opacity: 0,
          translate: [`${value}%`, 0, 0],
        },
        next: {
          translate: [`-${value}%`, 0, 0],
          scale: 0.9,
        },
      },
    };

    // Image card.
    if (imageEl && !imageEl.classList.contains("swiper-initialized")) {
      imageCarousel = new Swiper(imageEl, imageCarouselOption);

      const calcEdge = function () {
        let originLeft = imageEl.getBoundingClientRect().left,
          edge = [];

        imageEl.querySelectorAll(".swiper-slide").forEach(function (sl) {
          let edgeLeft = sl.getBoundingClientRect().left;
          if (!edge.includes(edgeLeft)) {
            edge.push(edgeLeft);
          }
        });

        if (originLeft <= Math.min(...edge)) {
          return;
        }

        let finalSpace = Math.round(originLeft - Math.min(...edge));

        imageEl.parentNode.setAttribute("data-edge-left", finalSpace);
        imageEl.parentNode.setAttribute(
          "style",
          "--edge-left:" + finalSpace + "px;",
        );

        // Start.
        const edgeEvent = new Event("edge-left-updated");

        const observer = new ResizeObserver(function () {
          let newElement = imageEl.parentNode.getBoundingClientRect().left,
            newEdge = [];

          imageEl.querySelectorAll(".swiper-slide").forEach(function (sl) {
            let newEdgeLeft = sl.getBoundingClientRect().left;
            if (!newEdge.includes(newEdgeLeft)) {
              newEdge.push(newEdgeLeft);
            }
          });

          edgeEvent.detail = {
            element: imageEl.parentNode,
            space: Math.round(originLeft - Math.min(...newEdge)),
          };

          document.dispatchEvent(edgeEvent);
        });

        // observer.observe( el );

        return observer;
      };

      calcEdge();
    }

    textCarouselOption = {
      speed: 300,
      slidesPerView: 1,
      loop: true,
      loopedSlides: 3,
      spaceBetween: 40,
    };

    if (el.classList.contains("image-layout")) {
      textCarouselOption.effect = "fade";

      textCarouselOption.fadeEffect = {
        crossFade: true,
      };
    }

    // Layout.
    if (el.classList.contains("content-layout")) {
      textCarouselOption.centeredSlides = true;
      textCarouselOption.spaceBetween = 200;

      if (mobile) {
        textCarouselOption.autoHeight = true;
      }
    } else {
      textCarouselOption.autoHeight = true;

      textCarouselOption.navigation = {
        nextEl: el.querySelector(".text-content .swiper-button-next"),
        prevEl: el.querySelector(".text-content .swiper-button-prev"),
      };

      textCarouselOption.pagination = {
        el: el.querySelector(".text-content .swiper-pagination"),
        clickable: true,
      };
    }

    // Text content.
    if (textEl && !textEl.classList.contains("swiper-initialized")) {
      textCarousel = new Swiper(textEl, textCarouselOption);
    }

    // Sync controls.
    if (textCarousel && imageCarousel) {
      textCarousel.controller.control = imageCarousel;
      imageCarousel.controller.control = textCarousel;
    }
  });

  document.addEventListener("edge-left-updated", function (e) {});
}
function btyShortDescription(doc = document) {
  let button = doc.querySelector(".read-more-btn");
  let short = doc.querySelector(".short-content");
  let content = doc.querySelector(".full-content");

  if (!short || !button || !content) {
    return;
  }

  if (button) {
    const buttonHandle = function () {
      if (content.style.display === "none") {
        short.style.display = "none";
        content.style.display = "block";
        button.textContent = btyStrings.product.read_less;
      } else {
        content.style.display = "none";
        short.style.display = "block";
        button.textContent = btyStrings.product.read_more;
      }
    };

    button.addEventListener("click", buttonHandle);
  }
}

// Update Progress Bar Cart.
function btyUpdateProgressBarCart(cartTotal, itemCount) {
  const progressWrapper = document.getElementById("cart-progress-wrapper");

  if (!progressWrapper) {
    return;
  }

  const moneyFormat = progressWrapper.dataset.moneyFormat;
  const preGoalMessageTemplate = progressWrapper.dataset.preGoalMessageTemplate;
  const postGoalMessage = progressWrapper.dataset.postGoalMessage;

  const progressBar = document.getElementById("cart-progress-bar");
  const goalMessageElement = document.querySelector(".goal-message");

  let progressThreshold = Math.round(
    progressWrapper.dataset.threshold * (Shopify.currency.rate || 1),
  );

  if (
    !moneyFormat ||
    !progressThreshold ||
    !preGoalMessageTemplate ||
    !postGoalMessage ||
    !progressBar ||
    !goalMessageElement
  ) {
    return;
  }

  if (itemCount === 0 || cartTotal === 0) {
    if (progressWrapper) {
      progressWrapper.style.display = "none";
    }
    if (goalMessageElement) {
      goalMessageElement.style.display = "none";
    }
  } else {
    if (progressWrapper) {
      progressWrapper.style.display = "block";
      progressWrapper.setAttribute(
        "data-threshold-selected-currency",
        progressThreshold,
      );
    }

    if (progressBar) {
      progressBar.style.display = "block";

      let progressPercentage = null;

      // console.log( cartTotal );

      if (cartTotal) {
        progressPercentage = Math.min(
          (cartTotal / progressThreshold) * 100,
          100,
        );
      } else {
        let sideCartPrice = document.querySelector(
          ".side-cart-footer .total-price",
        );
        if (sideCartPrice) {
          let total_price_str = sideCartPrice.textContent.replace(/\D/g, ""),
            total_price_number = Number(total_price_str);

          if (
            moneyFormat.includes("{{amount_no_decimals}}") ||
            moneyFormat.includes(
              "{{amount_no_decimals_with_comma_separator}}",
            ) ||
            moneyFormat.includes("{{amount_no_decimals_with_space_separator}}")
          ) {
            progressPercentage = Math.min(
              ((total_price_number * 100) / progressThreshold) * 100,
              100,
            );
          } else {
            progressPercentage = Math.min(
              (total_price_number / progressThreshold) * 100,
              100,
            );
          }
        }

        let mainCartPrice = document.querySelector(
          ".cart-page-section .cart-totals .totals-price",
        );
        if (mainCartPrice) {
          let total_price_str = mainCartPrice.textContent.replace(/\D/g, ""),
            total_price_number = Number(total_price_str);

          if (
            moneyFormat.includes("{{amount_no_decimals}}") ||
            moneyFormat.includes(
              "{{amount_no_decimals_with_comma_separator}}",
            ) ||
            moneyFormat.includes("{{amount_no_decimals_with_space_separator}}")
          ) {
            progressPercentage = Math.min(
              ((total_price_number * 100) / progressThreshold) * 100,
              100,
            );
          } else {
            progressPercentage = Math.min(
              (total_price_number / progressThreshold) * 100,
              100,
            );
          }
        }
      }

      progressBar.style.width = `${progressPercentage}%`;

      if (progressPercentage >= 100) {
        progressWrapper.classList.add("full");
      } else {
        progressWrapper.classList.remove("full");
      }
    }

    if (goalMessageElement) {
      goalMessageElement.style.display = "block";

      let remainingForGoal = null;

      if (cartTotal) {
        remainingForGoal = progressThreshold - cartTotal;
      } else {
        let sideCartPrice = document.querySelector(
          ".side-cart-footer .total-price",
        );
        if (sideCartPrice) {
          let total_price_str = sideCartPrice.textContent.replace(/\D/g, ""),
            total_price_number = Number(total_price_str);

          if (
            moneyFormat.includes("{{amount_no_decimals}}") ||
            moneyFormat.includes(
              "{{amount_no_decimals_with_comma_separator}}",
            ) ||
            moneyFormat.includes("{{amount_no_decimals_with_space_separator}}")
          ) {
            remainingForGoal =
              progressThreshold - Math.min(total_price_number * 100);
          } else {
            remainingForGoal = progressThreshold - total_price_number;
          }
        }

        let mainCartPrice = document.querySelector(
          ".cart-page-section .cart-totals .totals-price",
        );
        if (mainCartPrice) {
          let total_price_str = mainCartPrice.textContent.replace(/\D/g, ""),
            total_price_number = Number(total_price_str);

          if (
            moneyFormat.includes("{{amount_no_decimals}}") ||
            moneyFormat.includes(
              "{{amount_no_decimals_with_comma_separator}}",
            ) ||
            moneyFormat.includes("{{amount_no_decimals_with_space_separator}}")
          ) {
            remainingForGoal =
              progressThreshold - Math.min(total_price_number * 100);
          } else {
            remainingForGoal = progressThreshold - total_price_number;
          }
        }
      }

      if (remainingForGoal < 0) {
        remainingForGoal = 0;
      }

      let remainingAmount = remainingForGoal;

      let remainingAmountFormatted = btyFormatPrice(remainingAmount);

      const preGoalMessage = preGoalMessageTemplate.replace(
        "[remainingForGoalFormatted]",
        remainingAmountFormatted,
      );

      goalMessageElement.innerHTML =
        remainingForGoal > 0 ? preGoalMessage : postGoalMessage;
    }
  }
}

// Side cart click outer popup.
function btySideCartPopupOuter(doc = document) {
  let selector = doc.querySelector(".side-cart-inner"),
    overlay = selector ? selector.querySelector(".mini-cart-overlay") : false,
    popup = selector ? selector.querySelectorAll(".popup-toolDown") : false;

  if (!popup.length || !overlay) {
    return;
  }

  popup.forEach(function (el) {
    selector.addEventListener("mousedown", function (e) {
      if (!el.contains(e.target)) {
        if (
          el.classList.contains("open") &&
          overlay.classList.contains("open")
        ) {
          el.classList.remove("open");
          overlay.classList.remove("open");
        }
      }
    });
  });
}

// Cart checkbox agree to terms.
function btyAgreeToTerms(doc = document) {
  let selector = document.querySelectorAll(".agree-to-terms");

  if (!selector.length) {
    return;
  }

  selector.forEach(function (el) {
    let agreeCheckbox = el.querySelector("#agree");
    let checkoutButton = el.parentNode.querySelector('button[name="checkout"]');

    if (!agreeCheckbox || !checkoutButton) {
      return;
    }

    // Disable the checkout button initially.
    checkoutButton.disabled = true;

    agreeCheckbox.addEventListener("change", function () {
      checkoutButton.disabled = !this.checked;
      checkoutButton.focus();

      let sideCart = document.querySelector(".side-cart");

      if (sideCart) {
        btyTrapFocus(sideCart);
      }
    });
  });
}

// Side cart update product item when apply discount.
function btyUpdateDiscountSideCartItem(doc = document) {
  let item = doc.querySelectorAll(".side-cart .product-item[data-id]");
  if (!item.length) {
    return;
  }

  // Register dom html need an update when the response available.
  let modules = [
    {
      node: ".side-cart .cart-items",
      section: "side-cart",
      selector: ".side-cart .cart-items",
    },
    {
      node: ".side-cart .sub-total",
      section: "side-cart",
      selector: ".side-cart .sub-total",
    },
  ];

  item.forEach(function (el) {
    let id = el.getAttribute("data-id");

    if (!id) {
      return;
    }

    let discountApplyButton = el
      .closest(".side-cart")
      .querySelector(".side-cart-footer [data-update-coupon]");

    if (!discountApplyButton) {
      return;
    }

    discountApplyButton.onclick = function () {
      let inputs = el.querySelectorAll(".quantity-input");

      if (inputs.length) {
        inputs.forEach(function (input) {
          let data;

          data = {
            id: id,
            sections: modules.map((s) => s.section),
            sections_url: window.location.pathname,
          };

          // Fetch data.
          setTimeout(() => {
            btyFetchCart(data, modules, el);
          }, "500");
        });
      }
    };
  });
}
// DOM Loaded.
document.addEventListener("DOMContentLoaded", function () {
  if (typeof Shopify !== "undefined" && Shopify.theme?.schema_version) {
    document.documentElement.setAttribute(
      "data-v",
      Shopify.theme.schema_version,
    );
  }

  btyAccordionHover();
  // btyScrollBar();
  btyRecipientForm();
  btyNewsletterPopup();
  btyToggleDetails();
  btyQuickAdd();
  btyHoverMediaVideo();
  btyCollectionSticky();
  btyAnimationImageLoad();
  btyAccountPopup();
  btyProductTabs();
  btyCountdownTime();
  btyNavMenu();
  btyCookiesBar();
  btyQuantityButton();
  btySideCart();
  btyQuickSearch();
  btyAddToCart();
  btyAddMultiProductToCart();
  btyUpdateProductQuantity();
  btyQuickView();
  btySwatch();
  btyAccordionHandle();
  btyToggleDropdown();
  btyVideo();
  btyBackgroundVideo();
  btyAddress();
  btyPickupAvailabilityInit();
  btyProductVariants();
  btyProductPopup();
  btyProductShare();
  btyScrollAnimationTrigger();
  btyHeaderSticky();
  btyMediaDesktop();
  btyTextHoverImage();
  btyTextHoverShowImage();
  btySideCartPopupOuter();
  btyShortDescription();
  btyScrollToTop();
  btyTestimonialProduct();
  btyAgreeToTerms();
  btyUpdateProgressBarCart();
  btyToggleNavMenu();
  btyTogglePassword();
  btyUpdateDiscountSideCartItem();
  btyFeaturedBlogListHover();
  btyParallaxImage();
  btyFeaturedProuctListHover();

  window.addEventListener("resize", function () {
    btyMediaDesktop();
    btyTestimonialProduct();
    btyHeaderSticky();
  });

  window.addEventListener("scroll", function () {
    btyHeaderSticky();
    btyScrollingDetect();
    btyAnimationImageLoad();
  });
});

// Design mode event.
document.addEventListener("shopify:section:load", function (e) {
  let section = e.target;

  btyTextHoverImage(section);
  btyTextHoverShowImage(section);
  btyAccordionHover(section);
  btyAnimationImageLoad(section);
  btyCountdownTime(section);
  btyProductTabs(section);
  btyAccordionHandle(section);
  btyToggleDropdown(section);
  btyVideo(section);
  btyBackgroundVideo(section);
  btyAddress(section);
  btyProductVariants(section);
  btyProductPopup(section);
  btyProductShare(section);
  btyCollectionSticky(section);
  btyQuantityButton(section);
  btyScrollAnimationTrigger(section, true);
  btySideCartPopupOuter(section);
  btyTestimonialProduct(section);
  btyToggleNavMenu(section);
  btyTogglePassword(section);
  btyUpdateDiscountSideCartItem(section);
  btyFeaturedBlogListHover(section);
  btyParallaxImage(section);
  btyFeaturedProuctListHover(section);

  console.log("Section load.");
});
document.addEventListener("shopify:section:select", function (e) {
  let section = e.target;

  btyTextHoverImage(section);
  btyTextHoverShowImage(section);
  btyAccordionHover(section);
  btyQuickSearch();
  btyCookiesBar(section);
  btyNewsletterPopup(section);
  btyAnimationImageLoad(section);
  btyNavMenu(section, e);
  btyToggleDropdown(section);
  btyProductTabs(section);
  btyCountdownTime(section);
  btyAccordionHandle(section);
  btyVideo(section);
  btyBackgroundVideo(section);
  btyAddress(section);
  btyProductVariants(section);
  btyProductPopup(section);
  btyProductShare(section);
  btyAccountPopup(section);
  btyQuickAdd(section);
  // btyScrollBar(section);
  btyHoverMediaVideo(section);
  btySwatch(section);
  btyCollectionSticky(section);
  btyAddToCart(section);
  btyAddMultiProductToCart(section);
  btyQuantityButton(section);
  btySideCartPopupOuter(section);
  btyShortDescription(section);
  btyTestimonialProduct(section);
  btyToggleNavMenu(section);
  btyTogglePassword(section);
  btyFeaturedBlogListHover(section);
  btyParallaxImage(section);
  btyFeaturedProuctListHover(section);

  console.log("Section select.");
});
document.addEventListener("shopify:block:select", function (e) {
  console.log("Block select.");

  let section = document.getElementById(
    "shopify-section-" + e.detail.sectionId,
  );
  if (!section) {
    return;
  }

  btyAccordionHover(section);
  btyNewsletterPopup(section);
  btyAnimationImageLoad(section);
  btyProductTabs(section, e);
  btyCollectionSticky(section);
  btySideCartPopupOuter(section);
  btyShortDescription(section);
  btyTestimonialProduct(section);
});
document.addEventListener("shopify:section:reorder", function (e) {
  let section = e.target;

  btyScrollAnimationTrigger(section, true);

  console.log("Section reorder.");
});
